export const EL = {
  preparing_zip: "Προετοιμασία zip…",
  compressing: "Συμπίεση…",
  info_icon: "Μόλις σημειωθεί ως ολοκληρωμένο, δεν μπορούν να προσχωρήσουν ή να προστεθούν επιπλέον μέλη και όλες οι ομάδες συνομιλίας θα απενεργοποιηθούν. Παρακαλώ σημειώστε ότι το έργο, μαζί με όλες τις ομάδες συνομιλίας και τα δεδομένα, θα παραμείνει προσβάσιμο σε απενεργοποιημένη κατάσταση.",
  mark_is_done: "Είστε σίγουροι ότι θέλετε να σημειώσετε το έργο ως ολοκληρωμένο; Μόλις σημειωθεί, δεν μπορούν να προσχωρήσουν ή να προστεθούν επιπλέον μέλη και όλες οι ομάδες συνομιλίας θα απενεργοποιηθούν. Παρακαλώ σημειώστε ότι το έργο, μαζί με όλες τις ομάδες συνομιλίας και τα δεδομένα, θα παραμείνει προσβάσιμο σε απενεργοποιημένη κατάσταση.",
  mark_not_done: "Είστε σίγουροι ότι θέλετε να ανοίξετε ξανά το έργο; Μόλις σημειωθεί ως ανοιχτό, επιπλέον μέλη μπορούν να προσχωρήσουν ή να προστεθούν και όλες οι ομάδες συνομιλίας θα επανενεργοποιηθούν.",
  mark_as_completed: "Σημείωση έργου ως ολοκληρωμένου",
  room_completed: "Έργο ολοκληρώθηκε",
  room_members: "Μέλη έργου",
  deactivated_rooms: "Απενεργοποιημένα έργα",
  deactivated_chats: "Απενεργοποιημένες συνομιλίες",
  completed_rooms: "Ολοκληρωμένα έργα",
  request_to_join_a_room: 'Αίτημα για συμμετοχή στο έργο',
  wants_to_rejoin_room: 'Username θέλει να επανενταχθεί στο έργο Roomname.',
  invited_you_to_join_room: 'Username σας προσκάλεσε να συμμετάσχετε στο έργο Roomname.',
  restart: "Επανεκκίνηση",
  update_text: "Υπάρχει μια νέα ενημέρωση διαθέσιμη. Κάντε κλικ στην επανεκκίνηση για να εγκαταστήσετε την ενημέρωση.",
  update_availble: "Ενημέρωση διαθέσιμη",
  Loading: "Φόρτωση...",
  logout: "Αποσύνδεση",
  back: 'Πίσω',
  company_list: "Λίστα εταιρειών",
  followers: "Ακόλουθοι",
  followings: "Ακολουθούμενοι",
  article: "Άρθρο",
  companies: "Εταιρείες",
  one_to_one_chat: " Συνομιλία ένα προς ένα",
  profile: "Προφίλ",
  company: "Εταιρεία",
  company_selection: "Επιλογή εταιρείας",
  home: "Αρχική",
  contact: "Επικοινωνία ",
  add_company: "Προσθήκη εταιρείας ",
  add_project: "Προσθήκη έργου ",
  capacities: "Χωρητικότητες ",
  work_area: "Περιοχή εργασίας",
  company_services: "Υπηρεσίες εταιρείας",
  website: "Ιστοσελίδα",
  search_contacts: "Αναζήτηση επαφών",
  add_or_join_a_company: "Προσθήκη ή συμμετοχή σε εταιρεία",
  follow: "Ακολούθηση",
  following: "Ακολουθεί",
  like: "Μου αρέσει",
  company_contacts: "Επικοινωνία εταιρείας",
  leave_the_company: "Αποχώρηση από την εταιρεία",
  news: "Νέα",
  earlier: "Προηγούμενα",
  action: "Ενέργεια",
  another_action: "Άλλη ενέργεια",
  something_else: "Κάτι άλλο",
  search: "Αναζήτηση",
  search_rooms: "Αναζήτηση έργων",
  search_articles: "Αναζήτηση άρθρων",
  contacts: "Επαφές",
  suggestions: "Προτάσεις",
  project_list: "Λίστα έργων",
  search_results: "Αποτελέσματα αναζήτησης",
  add_or_join_project: "Προσθήκη ή συμμετοχή σε έργο",
  details: "Λεπτομέρειες",
  your_position_within_company:
    "Παρακαλώ επιλέξτε τη θέση σας στην εταιρεία.",
  close_modal: "Κλείσιμο",
  map: "Χάρτης",
  or: "Ή",
  name: "Όνομα*",
  street: "Οδός*",
  house_number: "Αριθμός οικίας",
  postal_code: "Ταχυδρομικός κώδικας",
  city: "Πόλη*",
  opened_by: "Άνοιξε από:",
  project_No: "Αριθμός έργου: ",
  building_type: "Τύπος κτιρίου*",
  building_types: "Τύπος κτιρίου",
  add_join: "Προσθήκη/Συμμετοχή",
  mandatory_fiels: "*υποχρεωτικά πεδία",
  invalid_fiels: "Αυτό το πεδίο είναι υποχρεωτικό",
  add_or_join_company: "Προσθήκη ή συμμετοχή σε εταιρεία",
  name_of_the_company: "Όνομα εταιρείας",
  edit_company_details: "Επεξεργασία λεπτομερειών εταιρείας",
  branch_of_the_building_industry: "Κλάδος της βιομηχανίας κατασκευών",
  corporate_form: "Εταιρική μορφή",
  position_within_company: "Θέση στην εταιρεία",
  request_confirmation: "Εκκρεμή αιτήματα έργων",
  company_e_mail: "E-mail εταιρείας",
  type_of_filter: "Πληκτρολογήστε για φιλτράρισμα...",
  setting: "Ρύθμιση",
  dashboard: "Πίνακας ελέγχου",
  settings: "Ρυθμίσεις",
  views: "Προβολές",
  times_seen: "φορές που εμφανίστηκε",
  see_more: "...περισσότερα",
  see_less: "...λιγότερα",
  in_search: "στην αναζήτηση",
  reset_password: "Επαναφορά κωδικού",
  submit: "Υποβολή",
  password: "Κωδικός",
  email: "E-mail",
  confirm_password: "Επιβεβαίωση κωδικού",
  reset_email: "Επαναφορά e-mail",
  update: "Ενημέρωση",
  new_email: "Νέο e-mail",
  kjuup_message: "Μήνυμα Kjuup",
  delete_profile: "Διαγραφή προφίλ;",
  my_position: "Η θέση μου:",
  add: "προσθήκη",
  owner_company_admin: "Διαχειριστής εταιρείας :",
  owner_company_admin_new: "Διαχειριστής εταιρείας",
  mutual_contact: "κοινή επαφή",
  mutual_contacts: "κοινές επαφές",
  co_owner: "Συνιδιοκτήτης",
  managing_director: "Γενικός διευθυντής",
  associate: "Συνεργάτης",
  secretary: "Γραμματέας",
  employee: "Υπάλληλος",
  project_manage: "Διευθυντής έργου",
  auto_chat_translation: "Αυτόματη μετάφραση συνομιλίας",
  translate_room_group_names: "Μετάφραση ονομάτων έργων και ομάδων",
  translate_room_group_names_info: "Όταν ενεργοποιηθεί, τα ονόματα έργων και ομάδων συνομιλίας μεταφράζονται αυτόματα στη γλώσσα διεπαφής.",
  default_view_email: "Default View: E-Mail",
  default_view_email_info: "Όταν ενεργοποιηθεί, η καρτέλα E-Mail θα ανοίγει από προεπιλογή αντί για τα Μηνύματα κατά το άνοιγμα της εφαρμογής.",
  integrate_email_in_messages: "Integrate E-Mail in Messages",
  integrate_email_in_messages_info: "When enabled, emails from all connected accounts will appear alongside your chat messages, sorted by date.",
  language: "Γλώσσα",
  english: "Αγγλικά",
  german: "Γερμανικά",
  french: "Γαλλικά",
  italian: "Ιταλικά",
  change_language: "Αλλαγή γλώσσας",
  my_companies: "Οι εταιρείες μου",
  employees: "Υπάλληλοι",
  invite_with_a: "Πρόσκληση στο Kjuup",
  add_member: "Προσθήκη μέλους",
  add_user: "Προσθήκη χρήστη",
  send_location: "Αποστολή τοποθεσίας",
  assign_admin_rights: "Προσαρμογή δικαιώματος διαχειριστή",
  deactivate_company: "Απενεργοποίηση εταιρείας",
  remove_employees: "Αφαίρεση υπαλλήλων",
  remove_members: "Αφαίρεση μελών",
  no_user_found: "Δεν βρέθηκε χρήστης!",
  approve: "Έγκριση!",
  deselect_all: "Αποεπιλογή όλων",
  select_all: "Επιλογή όλων",
  translation_on_building_projects: "Μετάφραση σε έργα",
  reported_capacities: "Αναφερόμενες υπηρεσίες",
  up_to_50m_exact: "Έως 50m ακριβώς",
  company_details_service: "Υπηρεσίες εταιρείας",
  company_contact: "Επικοινωνία εταιρείας",
  invite_with_link: "Πρόσκληση στο Kjuup",
  share_link: "Κοινοποίηση συνδέσμου",
  share_company_link: "Κοινοποίηση συνδέσμου",
  qr_code: "Κωδικός QR",
  copy_link: "Αντιγραφή συνδέσμου",
  cancel_link: "Ακύρωση συνδέσμου",
  who_has_confirmed_services: "Ποιος έχει επιβεβαιώσει τις υπηρεσίες σας;",
  projectss: "Έργα",
  add_services: "Προσθήκη υπηρεσιών",
  services: "Υπηρεσίες",
  save_text: "Αποθήκευση",
  share_on: "Κοινοποίηση σε:",
  articlen: "Άρθρο",
  invite_user_to_confirm_service:
    "Προσκαλέστε χρήστες να επιβεβαιώσουν υπηρεσίες στην εταιρεία.",
  link_copied: "Σύνδεσμος αντιγράφηκε!",
  email_copied: "E-mail αντιγράφηκε!",
  personal_article: "Προσωπικό άρθρο",
  company_article: "Άρθρο εταιρείας",
  characters_remaining: "Υπόλοιποι χαρακτήρες",
  optional_information: "Προαιρετικές πληροφορίες",
  project: "Έργο",
  projects: "Έργα...",
  abort: "Απόρριψη",
  preview: "Προεπισκόπηση",
  post: "Δημοσίευση",
  of: "από",
  remove: "Αφαίρεση",
  free_capacity: "Πύλη εργασίας",
  current_status_overview: "Επισκόπηση τρέχουσας κατάστασης",
  report_capacities: "Αναφορά υπηρεσιών",
  report_text: "Αναφορά",
  search_capacities: "Εύρεση εργολάβων",
  add_project_user: "Προσθήκη χρήστη έργου",
  media: "Μεσα",
  links: "Συνδεσμοι",
  docs: "Εγγραφα",
  featured_products: "Προτεινόμενα προϊόντα...",
  title: "Τίτλος",
  text: "Κείμενο",
  feed_details: "Λεπτομέρειες ροής",
  add_employee: "Προσθήκη υπαλλήλου",
  latest: "Τελευταία",
  my_projects: "Τα έργα μου",
  cancel: "Ακύρωση",
  continue: "Συνέχεια",
  role_in_the_building_industry: "Ρόλος στη βιομηχανία κατασκευών",
  als: "ως",
  join: "συμμετοχή",
  find: "Εύρεση",
  request_to_join_a_company: "Αίτημα για συμμετοχή στην εταιρεία",
  wants_to_join_the_company: "θέλει να συμμετάσχει στην εταιρεία",
  filter_by: "Φιλτράρισμα κατά",
  ok: "Εντάξει",
  close: "Κλείσιμο",
  weekly_statistics: "Εβδομαδιαία στατιστικά",
  is_following_you: "σας ακολουθεί.",
  as: "ως",
  has_joined_the: "έχει συμμετάσχει στην εταιρεία",
  has_looked_at_your_profile: "έχει δει το προφίλ σας.",
  time: "Ώρα",
  in_searches_in_past_week: "σε αναζητήσεις την περασμένη εβδομάδα.",
  has_liked_your_article: "έχει συμπαθήσει το άρθρο σας.",
  has_published_a_new_article: "έχει δημοσιεύσει ένα νέο άρθρο.",
  you: "Εσείς",
  all_views: "Όλες οι προβολές",
  all_profile_views: "Όλες οι προβολές προφίλ",
  mutual_company: "κοινή εταιρεία",
  artical_text: "Γράψτε άρθρο...",
  you_have_appeared: "Έχετε εμφανιστεί",
  your_request_at_the_company: "Το αίτημά σας στην εταιρεία",
  times_you_have_appeared_in_searches: "φορές που έχετε εμφανιστεί σε αναζητήσεις",
  appear_more_often_in_searches: "Εμφανίζεστε πιο συχνά σε αναζητήσεις",
  you_have_been_found: "Έχετε βρεθεί",
  improve_profile: "Βελτίωση προφίλ",
  choose_existing_contact_for_single_chat:
    "Επιλέξτε υπάρχουσα επαφή για ατομική συνομιλία:",
  in_order_to_add_new_contacts:
    "Για να προσθέσετε νέες επαφές, παρακαλώ αναζητήστε νέες επαφές στη σελίδα προφίλ.",
  times_in_searches_in_the_last_week:
    "φορές σε αναζητήσεις την τελευταία εβδομάδα. Ενημερώστε το προφίλ σας και προσθέστε περισσότερες λεπτομέρειες για να βρεθείτε πιο εύκολα.",
  has_been_confirmed: "έχει επιβεβαιωθεί.",
  have_joined_the: "έχουν συμμετάσχει στο  ",
  building_project: " έργο κατασκευής.",
  select_with_which_company_you_want_to_connect_to_the_project:
    "Επιλέξτε την εταιρεία που θα εκπροσωπείτε. Αυτό θα εμφανιστεί σε άλλους συμμετέχοντες.",
  select_with_which_company_you_want_to_connect_to_the_chat:
    "Επιλέξτε την εταιρεία που θα εκπροσωπείτε. Αυτό θα εμφανιστεί σε άλλους συμμετέχοντες.",
  select_internal_section: "Παρακαλώ επιλέξτε εσωτερικό τμήμα",
  select_profile_image: "Επιλογή εικόνας προφίλ",
  share_user: "Κοινοποίηση χρήστη",
  contact_sender_message:
    "Κοινοποιήστε αυτόν τον σύνδεσμο για να προσκαλέσετε έναν μη μέλος του Kjuup στο Kjuup. Αυτός ο σύνδεσμος μπορεί να χρησιμοποιηθεί από πολλά άτομα για εγγραφή.",
  project_sender_message:
    "Κοινοποιήστε αυτόν τον σύνδεσμο για να προσκαλέσετε έναν μη μέλος του Kjuup στο έργο όνομα έργου. Αυτός ο σύνδεσμος μπορεί να χρησιμοποιηθεί από πολλά άτομα για εγγραφή και συμμετοχή στο έργο όνομα έργου στο Kjuup.",
  company_sender_message:
    "Κοινοποιήστε αυτόν τον σύνδεσμο για να προσκαλέσετε έναν μη μέλος του Kjuup στην εταιρεία όνομα εταιρείας. Αυτός ο σύνδεσμος μπορεί να χρησιμοποιηθεί από πολλά άτομα για εγγραφή και συμμετοχή στην εταιρεία στο Kjuup.",
  contact_receivers_message:
    "Σύνδεσμος πρόσκλησης για συμμετοχή στο Kjuup. Παρακαλώ κάντε κλικ στον σύνδεσμο για εγγραφή στο kjuup.",
  iphone: "iPhone:",
  iphone_recivers_message:
    "Σε περίπτωση που εγκαθιστάτε το Kjuup μέσω του Apple App Store, πρέπει να κάνετε κλικ σε αυτόν τον σύνδεσμο μετά την επιτυχή λήψη, για να μπορέσετε να εγγραφείτε.",
  project_receivers_message:
    "Σύνδεσμος πρόσκλησης για συμμετοχή στο έργο όνομα έργου στο Kjuup. Παρακαλώ κάντε κλικ στον σύνδεσμο για εγγραφή στο Kjuup και συμμετοχή στο έργο όνομα έργου.",
  company_receivers_message:
    "Σύνδεσμος πρόσκλησης στην εταιρεία όνομα εταιρείας στο Kjuup. Παρακαλώ κάντε κλικ στον σύνδεσμο για εγγραφή στο Kjuup και συμμετοχή στην εταιρεία όνομα εταιρείας.",
  sign_in: "Σύνδεση",
  enter_your_email_add: "Εισάγετε τη διεύθυνση e-mail σας",
  forgot_password: "Ξεχάσατε τον κωδικό;",
  dont_have_account: "Δεν έχετε λογαριασμό;",
  register: "Εγγραφή",
  get_app: "Λήψη εφαρμογής",
  registration: "Εγγραφή",
  dep_ing: "Dipl.-Ing.",
  dr: "Δρ.",
  dr_ing: "Δρ.-Ing.",
  dep_ing_arc: "Dipl.-Ing. Αρχιτέκτονας",
  prof: "Καθ.",
  first_name: "Όνομα",
  last_name: "Επώνυμο",
  have_an_account: "Έχετε λογαριασμό;",
  when_register_you_agree: "Κατά την εγγραφή συμφωνείτε με τους",
  term_of_use: "όρους χρήσης",
  to: "μας.",
  in_our: "Στην",
  data_policy: "πολιτική δεδομένων",
  they_find_out: "μας μάθετε,",
  we_provide_store_data: "πώς συλλέγουμε, επεξεργαζόμαστε και αποθηκεύουμε πληροφορίες.",
  leaving_company_text:
    "Θέλετε πραγματικά να αποχωρήσετε από την εταιρεία; Όταν αποχωρείτε από την εταιρεία, αποχωρείτε επίσης από όλα τα σχετικά έργα και ομάδες συνομιλίας. Μπορείτε να συμμετάσχετε ξανά σε αυτά τα έργα με άλλη εταιρεία οποιαδήποτε στιγμή.",
  delete_profile_text:
    "Θέλετε πραγματικά να διαγράψετε το προφίλ σας; Όταν διαγράψετε το προφίλ σας, όλες οι συνδέσεις με εταιρείες, έργα και συνομιλίες θα αφαιρεθούν. Μπορείτε να δημιουργήσετε ένα νέο προφίλ οποιαδήποτε στιγμή.",
  confirm: "Επιβεβαίωση",
  reject: "Απόρριψη",
  requet_to_leave: "Αίτημα για αποχώρηση",
  choose: "Επιλογή",
  your_add_member: "Προσθήκη μέλους",
  if_you: "σε περίπτωση που",
  can_not_find: "δεν μπορείτε να βρείτε την επαφή σας εδώ.",
  please_wait: "Παρακαλώ περιμένετε..",
  imprint_gtc: "Αποτύπωμα/Όροι χρήσης",
  register_confirm_popup: "Επιβεβαιώστε τη διεύθυνση email Kjuup πριν συνδεθείτε. Σας στείλαμε σύνδεσμο επιβεβαίωσης. Αν δεν τον βλέπετε, ελέγξτε και τον φάκελο spam.",
  PENDING_GROUP_USER:
    "θα λάβει μηνύματα μόνο αφού επιβεβαιωθεί η πρόσκληση στο έργο. Ένα επιπλέον μήνυμα θα εμφανιστεί μόλις επιβεβαιωθεί η πρόσκληση στο έργο.",
  PENDING: "Εκκρεμεί επιβεβαίωση πρόσκλησης στο έργο",
  denied_group_chat: " έχει αρνηθεί την πρόσκληση στο έργο και έχει αποχωρήσει από αυτή την ομάδα.",
  // joined_group_chat: " έχει συμμετάσχει στο δωμάτιο και αυτή την ομάδα.",
  joined_group_chat: " συμμετείχε σε αυτή την ομάδα",
  you_joined_group_chat: "Συμμετείχατε σε αυτή την ομάδα.",
  Others: "Άλλοι",
  LEFT_GROUP: "έχει αποχωρήσει από αυτή την ομάδα συνομιλίας.",
  YOU_LEFT_GROUP: "έχετε αποχωρήσει από αυτή την ομάδα συνομιλίας.",
  days: "ημέρες",
  day: "ημέρα",
  hour: "ώρα",
  hide_project: "Απόκρυψη έργου",
  hide_project_popup_text:
    "Εάν αποκρύψετε έργα, δεν μπορούν να βρεθούν στο Kjuup. Μόνο τα μέλη του έργου μπορούν να προσκαλέσουν νέους χρήστες στο έργο.",
  branch: "Κλάδος",
  photo_video_media_lib: "Βιβλιοθήκη μέσων - Φωτογραφία και βίντεο",
  document: "Έγγραφο",
  location_meeting: "Τοποθεσία / Συνάντηση",
  all_member_of_project: "Όλα τα μέλη του έργου",
  pending_request: "Εκκρεμή αιτήματα έργων",
  no_pending_request: "Δεν βρέθηκαν εκκρεμή αιτήματα!",
  news_feed: "Ροή ειδήσεων",
  user_info: "Πληροφορίες ομάδας",
  leave_project: "Αποχώρηση από έργο",
  media_link_docs: "Αρχεία",
  search_chat: "Αναζήτηση συνομιλίας",
  export_chat_group: "Εξαγωγή δεδομένων ομάδας συνομιλίας από τον περασμένο μήνα",
  request_complete_chat_history: "Αίτημα πλήρους ιστορικού συνομιλίας",
  leave_chat_group: "Αποχώρηση από ομάδα συνομιλίας",
  add_user_project: "Προσθήκη χρήστη",
  me: "Εγώ",
  max_open_one_to_one:
    "Επί του παρόντος μπορούν να ανοίξουν παράλληλα μέγ. 2 συνομιλίες ένα προς ένα στο κάτω και στο πάνω τμήμα. Συνολικά είναι δυνατές μέγ. 4 συνομιλίες ένα προς ένα.",
  are_you_sure_you_want_leave_chat:
    "Είστε σίγουροι ότι θέλετε να αποχωρήσετε από αυτή την ομάδα συνομιλίας;",
  create_group: "Δημιουργία ομάδας",
  adding_members: "Προσθήκη μελών...",
  creating_the_chat: "Δημιουργία συνομιλίας...",
  finishing_setup: "Ολοκλήρωση...",
  group_name: "Όνομα ομάδας",
  by: "Από:",
  mandetory: "*υποχρεωτικό",
  delteed: "έχει διαγράψει το προφίλ του/της και έχει αποχωρήσει από τη συνομιλία ομάδας.",
  deleted_direct: "έχει διαγράψει το προφίλ του/της και έχει αποχωρήσει από τη συνομιλία.",
  unhidden_message:
    "Εάν μην αποκρύψετε έργα, μπορούν να βρεθούν από όλα τα μέλη του Kjuup.",
  account_deleted: "Ο λογαριασμός έχει διαγραφεί.",
  refuse_company: "Είστε σίγουροι ότι θέλετε να αρνηθείτε την πρόσκληση της εταιρείας;",
  follow_additional: "Ακολούθηση επιπλέον χρηστών",
  f_add:
    "Ακολουθήστε επιπλέον χρήστες του Kjuup για να τους κάνετε διαθέσιμους για άμεσα μηνύματα.",
  c_inv: "Πρόσκληση(εις) εταιρείας",
  invited_o_Company: "Έχετε προσκληθεί να συμμετάσχετε στην εταιρεία",
  refuse_companyX: "Είστε σίγουροι ότι θέλετε να αρνηθείτε το αίτημα της εταιρείας;",
  a_Da: "Ο λογαριασμός απενεργοποιήθηκε.",
  has_deactivated: "έχει απενεργοποιήσει το προφίλ του/της.",
  reactive: "έχει επανενεργοποιήσει το προφίλ του/της.",
  juup_note: "*Η εγγραφή με όνομα χρήστη διαθέσιμη μόνο για μέλη του Kjuup+",
  username: "Όνομα χρήστη*",
  email_username: "E-mail/Όνομα χρήστη*",
  sPinText:
    "Παρακαλώ δώστε ένα 6ψήφιο PIN ασφαλείας. Αυτό το PIN θα χρειαστεί σε περίπτωση που ξεχάσετε τον κωδικό σας και είναι υποχρεωτικό για την επιβεβαίωση του λογαριασμού σας.",
  DeleteKjuupPlusText:
    "Θέλετε πραγματικά να διαγράψετε το προφίλ σας; Όταν διαγράψετε το προφίλ σας, όλες οι συνδέσεις με εταιρείες, έργα και συνομιλίες θα αφαιρεθούν.\n\nΕντός 48 ωρών μετά τη διαγραφή λογαριασμού μπορείτε να επανενεργοποιήσετε τον λογαριασμό σας συνδεόμενοι με όνομα χρήστη, κωδικό και PIN.",
  reactive_text:
    "Ο λογαριασμός σας έχει διαγραφεί. Παρακαλώ κάντε κλικ στην Επανενεργοποίηση για να επανενεργοποιήσετε τον λογαριασμό σας.",
  rac: "Επανενεργοποίηση",
  ac_ss: "Ο λογαριασμός επανενεργοποιήθηκε επιτυχώς.",
  not_valid_pin: "PIN μη έγκυρο",
  only_for_kjuup:
    "*Η επαναφορά κωδικού μέσω ονόματος χρήστη και PIN διαθέσιμη μόνο για μέλη του Kjuup+.",
  resetPIN: "Επαναφορά PIN",
  enter_current_pin: "Παρακαλώ εισάγετε το τρέχον PIN σας",
  enter_new: "Εισάγετε νέο PIN",
  pin_to_confirm: "Παρακαλώ δώστε το PIN για επιβεβαίωση.",
  change_username: "Επαναφορά ονόματος χρήστη",
  pp_not_match: "Ο κωδικός και η επιβεβαίωση κωδικού δεν ταιριάζουν",
  reactive_itself: "Έχετε επανενεργοποιήσει το προφίλ σας.",
  has_deactivated_itself: "Έχετε απενεργοποιήσει το προφίλ σας.",
  more_than_two:
    "Επί του παρόντος τα άμεσα μηνύματα μπορούν να γίνουν μόνο με 2 χρήστες παράλληλα.",
  Chats: "Άμεσα μηνύματα",
  only_in_mobileL:
    "Τα εγγενή βίντεο μπορούν επί του παρόντος να ανέβουν και να δημοσιευτούν μόνο μέσω της εφαρμογής κινητού. Παρακαλώ χρησιμοποιήστε συνδέσμους βίντεο από το Youtube και το Vimeo.",
  register_pin_text:
    "Παρακαλώ επιλέξτε το προσωπικό σας 6ψήφιο PIN. Αυτό το PIN θα χρειαστεί για την ενεργοποίηση λειτουργιών επαναφοράς λογαριασμού.",
  internal_project: "Εσωτερικό",
  external_projects: "Εξωτερικό",
  in_deacticted: "Το εσωτερικό τμήμα είναι απενεργοποιημένο.",
  create_article: "Δημιουργία άρθρου",
  new_article_selection: "Δημιουργία άρθρου για εξωτερική ροή ειδήσεων",
  new_article_selection_internal: "Δημιουργία εσωτερικού άρθρου",
  active_trans_title: "Ενεργοποίηση αυτόματης μετάφρασης;",
  active_trans: "Όταν ενεργοποιηθεί, όλα τα εισερχόμενα μηνύματα συνομιλιών θα μεταφραστούν στη γλώσσα εφαρμογής που έχετε επιλέξει.",
  disable_trans: "Θέλετε πραγματικά να απενεργοποιήσετε την αυτόματη μετάφραση;",
  allow_access_chat: "Εμφάνιση πλήρους ιστορικού συνομιλίας",
  toggle_chat_history_on:
    "Θέλετε πραγματικά ο χρήστης να δει το πλήρες ιστορικό συνομιλίας;",
  toggle_chat_history_off:
    "Θέλετε πραγματικά ο χρήστης να δει μόνο το ιστορικό συνομιλίας από το σημείο συμμετοχής στη συνομιλία;",
  check_selected_settings:
    "Παρακαλώ ελέγξτε τις ρυθμίσεις ιστορικού συνομιλίας για όλους τους επιλεγμένους χρήστες!",
  chat_from_start_have:
    "Έχετε συμμετάσχει σε αυτή την ομάδα. Το ιστορικό συνομιλίας έχει κοινοποιηθεί.",
  chat_from_start_has:
    "έχει συμμετάσχει σε αυτή την ομάδα. Το ιστορικό συνομιλίας έχει κοινοποιηθεί.",
  Address: "Διεύθυνση",
  read_by: "Διαβάστηκε από",
  deliver_to: "Παραδόθηκε σε",
  remaining: "υπόλοιπο",
  message_info: "Πληροφορίες μηνύματος",
  request_to_join_only: "Αίτημα για συμμετοχή",
  unfollow: "Κατάργηση ακολούθησης",
  company_username: "Όνομα χρήστη",
  month: [
    "Ιαν",
    "Φεβ",
    "Μαρ",
    "Απρ",
    "Μαϊ",
    "Ιουν",
    "Ιουλ",
    "Αυγ",
    "Σεπ",
    "Οκτ",
    "Νοε",
    "Δεκ",
  ],
  remove_my_admin_right: "Αφαίρεση δικαιωμάτων διαχειριστή μου",
  makeEmp: "Θέλετε πραγματικά να αφαιρέσετε τα δικαιώματα διαχειριστή εταιρείας από τον χρήστη;",
  remove_my_self:
    "Θέλετε πραγματικά να αφαιρέσετε τα δικαιώματα διαχειριστή εταιρείας από τον λογαριασμό σας;",
  makeAdmin: "Θέλετε πραγματικά να δώσετε στον χρήστη δικαιώματα διαχειριστή εταιρείας;",
  remove_member: "Αφαίρεση μέλους",
  remove_following_confirm: "Θέλετε πραγματικά να αφαιρέσετε το {name} από τη λίστα ακολούθων;",
  remove_follower_confirm: "Θέλετε πραγματικά να αφαιρέσετε το {name} από όσους σας ακολουθούν; Αν τον/την αφαιρέσετε, δεν θα ενημερωθεί.",
  do_you_really_want_to_remove:
    "Θέλετε πραγματικά να αφαιρέσετε το όνομα χρήστη από την εταιρεία;",
  invite_all: "Πρόσκληση όλων των μελών της εταιρείας",
  invite_all_members: "Πρόσκληση όλων των μελών",
  mems: "Όλα τα άλλα μέλη",
  dep_loc: "Τμήμα/Τοποθεσία/Ομάδα",
  depAdmin: "Διαχειριστής τμήματος",
  add_remove_admin: "Προσθήκη/Αφαίρεση θέσης διαχειριστή εταιρείας",
  add_remove_dep_admin: "Προσθήκη/Αφαίρεση θέσης διαχειριστή τμήματος",
  remove_employees_dept: "Αφαίρεση υπαλλήλων από",
  want_to_join_dep:
    "Το όνομα χρήστη θέλει να συμμετάσχει στο Τμήμα/Τοποθεσία/Ομάδα depname της εταιρείας companyname.",
  you_invited:
    "Έχετε προσκληθεί να συμμετάσχετε στο Τμήμα/Τοποθεσία/Ομάδα depname της εταιρείας companyname.",
  dep_remove:
    "Θέλετε πραγματικά να αφαιρέσετε τα δικαιώματα διαχειριστή τμήματος ή τοποθεσίας από τον χρήστη;",
  add_dep:
    "Θέλετε πραγματικά να δώσετε στον χρήστη δικαιώματα διαχειριστή για το τμήμα ή την τοποθεσία;",
  my_self_dep_remove:
    "Θέλετε πραγματικά να αφαιρέσετε τα δικαιώματα διαχειριστή τμήματος από τον λογαριασμό σας;",
  member: "Μέλος",
  admin: "Διαχειριστής",
  remove_project_admin:
    "Θέλετε πραγματικά να αφαιρέσετε το μέλος από το έργο;",
  remove_my_self_project: "Θέλετε πραγματικά να αφαιρέσετε τα δικαιώματα διαχειριστή;",
  remove_member_admin_right:
    "Θέλετε πραγματικά να αφαιρέσετε τα δικαιώματα διαχειριστή από τον χρήστη;",
  add_member_admin_right: "Θέλετε πραγματικά να προσθέσετε δικαιώματα διαχειριστή στον χρήστη;",
  add_remove_Poss: "Προσθήκη/Αφαίρεση θέσης διαχειριστή",
  forward: "Προώθηση",
  edit: "Επεξεργασία",
  only_kjuup_plus_can: "Μόνο οι εταιρείες Kjuup+ μπορούν να δημοσιεύουν άρθρα.",
  add_images: "Προσθήκη εικόνας(ων)",
  request_confirmation: 'Εκκρεμείς προσκλήσεις έργων',
  Activity: "Δραστηριότητα",
  latest_messages: "Τελευταία μηνύματα",
  hours: "ώρες",
  minute: "λεπτά",
  seconds: "δευτερόλεπτα",
  days: "ημέρες",
  yesterday: "χθες",
  last_week: "την περασμένη εβδομάδα",
  next_week: "την επόμενη εβδομάδα",
  Last_month: "τον περασμένο μήνα",
  All: "Όλα",
  register_plus: "Εγγραφή Plus",
  select_files: "Επιλογή αρχείων",
  monthsFullName: [
    "Ιανουάριος",
    "Φεβρουάριος",
    "Μάρτιος",
    "Απρίλιος",
    "Μάιος",
    "Ιούνιος",
    "Ιούλιος",
    "Αύγουστος",
    "Σεπτέμβριος",
    "Οκτώβριος",
    "Νοέμβριος",
    "Δεκέμβριος",
  ],
  company_deploc_receivers_message:
    "Σύνδεσμος πρόσκλησης στο τμήμα της εταιρείας όνομα εταιρείας στο Kjuup. Παρακαλώ κάντε κλικ στον σύνδεσμο για εγγραφή στο Kjuup και συμμετοχή στην εταιρεία όνομα εταιρείας.",
  no_news: "Δεν υπάρχουν διαθέσιμες ειδήσεις",
  reminder: "Υπενθύμιση",
  np_reminder: "Χωρίς εργασίες",
  move_to_reminder: "Μετακίνηση σε εργασία",
  remove_reminder: "Θέλετε πραγματικά να αφαιρέσετε αυτό το μήνυμα από τη λίστα των εργασιών σας;",
  remove_all_reminder: "Αφαίρεση όλων των εργασιών",
  remove_all_confirm: "Θέλετε πραγματικά να αφαιρέσετε όλα τα μηνύματα από τη λίστα των εργασιών σας;",
  remove_from_reminder: "Αφαίρεση από υπενθύμιση",
  prevent_email: "Το E-mail δεν μπορεί να χρησιμοποιηθεί ως Όνομα χρήστη.",
  allow_noti: "Παρακαλώ επιτρέψτε τις ειδοποιήσεις.",
  join_cap: "Συμμετοχή",
  pass_minimum:
    "**Ο κωδικός απαιτεί 12 χαρακτήρες συμπεριλαμβανομένων μικρού -, κεφαλαίου γράμματος, αριθμού και ειδικού χαρακτήρα.",
  pass_error: "Παρακαλώ ελέγξτε τις απαιτήσεις κωδικού",
  people_that_like_article: "Άτομα που συμπαθούν το άρθρο.",
  people_who_like_article: "Άτομα που συμπαθούν το άρθρο σας.",
  message_delete: "Αυτό το μήνυμα έχει διαγραφεί.",
  message_edited: "επεξεργάστηκε",
  edit_message: "Επεξεργασία μηνύματος",
  edit_window_expired: "Τα μηνύματα μπορούν να επεξεργαστούν μόνο εντός 10 λεπτών από την αποστολή.",
  message_edit_save: "Αποθήκευση",
  copy: "Αντιγραφή",
  bookmark: "Σελιδοδείκτης",
  add_reaction: "Προσθήκη αντίδρασης",
  delete_message: "Διαγραφή μηνύματος",
  more_options: "Περισσότερες επιλογές",
  info: "Πληροφορίες",
  link_invite: "Πρόσκληση μέσω συνδέσμου",
  ll_nkk: "Πρόσκληση στο Kjuup",
  selected: "Επιλεγμένο",
  is_active: "Ενεργό",
  inactive: "Ανενεργό",
  last_online: "τελευταία σύνδεση {{when}}",
  remove_user_l: "Αφαίρεση",
  link_expire: "Κάθε δημιουργημένος σύνδεσμος θα είναι έγκυρος για 72 ώρες.",
  company_language: "Γλώσσα εταιρείας",
  company_language_info:
    "Η επιλογή γλώσσας θα χρησιμοποιηθεί για όλες τις επιβεβαιώσεις e-mail σχετικά με την εταιρεία.",
  s_image: "εικόνα",
  m_image: "εικόνες",
  removeMsg: "Πατήστε για αφαίρεση",
  block: 'Αποκλεισμός',
  unblock: 'Κατάργηση αποκλεισμού',
  blocks: 'Είστε σίγουροι ότι θέλετε να αποκλείσετε αυτόν τον χρήστη;',
  unblocks: 'Είστε σίγουροι ότι θέλετε να καταργήσετε τον αποκλεισμό αυτού του χρήστη;',
  bolcked_click_un_block:
    'Έχετε αποκλείσει αυτή την επαφή. Κάντε κλικ εδώ για αφαίρεση αποκλεισμού.',
  you_have_unblocked: 'Έχετε καταργήσει τον αποκλεισμό αυτής της επαφής.',
  you_have_blocked: 'Έχετε αποκλείσει αυτή την επαφή.',
  unblock_to_send: 'Κατάργηση αποκλεισμού χρήστη για αποστολή μηνύματος.',
  pilot_text: "Εξειδικευμένη AI για θέματα κατασκευών",
  startup_screen_label: "Οθόνη εκκίνησης",
  startup_screen_info: "Επιλέξτε ποια οθόνη ανοίγει όταν ξεκινά το Kjuup.",
  startup_screen_feed: "Home",
  startup_screen_messages: "Μηνύματα",
  startup_screen_saved: "Η οθόνη εκκίνησης ενημερώθηκε",
email_on: "Ειδοποιήσεις e-mail συνομιλιών",
  email_on_grp: "Ειδοποίηση e-mail",
  article_email_on: "Email notification articles",
  article_email_info: "If you enable email notifications for internal articles, you will receive an email when a new internal article is published in your company and department.",
  info_email_room: "Ενεργοποίηση ή απενεργοποίηση ειδοποιήσεων e-mail για αυτό το έργο. Αυτή η επιλογή είναι διαθέσιμη μόνο όταν οι \"Ειδοποιήσεις e-mail συνομιλιών\" είναι ενεργοποιημένες μέσω προσωπικών ρυθμίσεων.",
  todo_notification_info: "Θα ειδοποιείστε κάθε φορά που σας ανατίθεται μια νέα εργασία.",
  info_val: "Θα λάβετε ένα e-mail εάν ένα νέο μήνυμα συνομιλίας δεν διαβαστεί σε σύντομο χρονικό διάστημα. Μπορείτε να το απενεργοποιήσετε για συγκεκριμένα έργα ή συνομιλίες στις ρυθμίσεις τους ή στις πληροφορίες της ομάδας συνομιλίας.",
  email_groups: "Ενεργοποίηση ή απενεργοποίηση ειδοποιήσεων e-mail για αυτή τη συνομιλία. Αυτή η επιλογή είναι διαθέσιμη μόνο όταν οι \"Ειδοποιήσεις e-mail συνομιλιών\" είναι ενεργοποιημένες μέσω προσωπικών και ρυθμίσεων έργου.",
  add_update_email: "Προσθήκη/Ενημέρωση e-mail",
  text_to_verifiy: "Η επιλογή \"Ειδοποιήσεις e-mail συνομιλιών\" μπορεί να ενεργοποιηθεί μόνο εάν έχετε μια επαληθευμένη διεύθυνση e-mail στο αρχείο.",
  stored_email: "Αποθηκευμένο e-mail: ",
  verify_email: "Εκκρεμεί επιβεβαίωση!",
  join_call:"Συμμετοχή",
  call_is_started:"Η κλήση ξεκίνησε",
  start_chat:"Έναρξη άμεσης συνομιλίας;",
  project_rooms:"Έργα",
  download_selected:"Λήψη",
  add_employee_confirm: 'Είστε σίγουροι ότι θέλετε να προσθέσετε αυτόν τον χρήστη στην εταιρεία;',
  invalid_deeplink: "Μη έγκυρο URL βαθύ συνδέσμου. Λείπουν απαιτούμενες παράμετροι.",
  deeplink_error: "Αδυναμία επεξεργασίας βαθύ συνδέσμου. Παρακαλώ δοκιμάστε ξανά αργότερα.",
  // Reply functionality translations
  reply: "Απάντηση",
  reply_enter: "Εισάγετε απάντηση...",
  reply_sent_successfully: "Η απάντηση στάλθηκε επιτυχώς",
  reply_failed: "Αποτυχία αποστολής απάντησης",
  reply_failed_generic: "Αποτυχία αποστολής απάντησης. Παρακαλώ δοκιμάστε ξανά.",
  replying_to_message: "Απάντηση στο μήνυμα",
  cancel_reply: "Ακύρωση απάντησης",
  voice_message: "Φωνητικό μήνυμα",
  send: "Αποστολή",
  cancel: "Ακύρωση",
  type_your_reply: "Πληκτρολογήστε την απάντησή σας...",
  
  // Auto-suggestion translations
  suggested_replies: "Προτεινόμενες απαντήσεις",
  suggestions_error: "Αποτυχία φόρτωσης προτάσεων",
  positive_suggestion_placeholder: "Positive",
  neutral_suggestion_placeholder: "Neutral",
  negative_suggestion_placeholder: "Negative",
  lazy_media_image: "Image — Click to load",
  lazy_media_audio: "Voice message — Click to load",
  lazy_media_doc: "Document — Click to load",
  lazy_media_video: "Video — Click to load",
  suggestion_loading_message: "Μια στιγμή. Το κείμενό σας προετοιμάζεται ατομικά για εσάς.",
  loading_chat_message: "Φόρτωση συνομιλίας...",
  
  // Manual ToDo translations
  extracting_message: "Εξαγωγή μηνύματος...",
  create_todo: "Δημιουργία εργασίας",
  create_todo_confirmation: "Θέλετε να δημιουργήσετε μια εργασία από αυτό το μήνυμα;",
  select_project_required: "Παρακαλώ επιλέξτε ένα έργο/ομάδα",
  only_assigned_can_change_status: "Μόνο οι ανατεθέντες χρήστες μπορούν να αλλάξουν κατάσταση",
  todo_summary: "Σύνοψη",
  todo_summary_placeholder: "Εισάγετε σύνοψη εργασίας...",
  todo_date: "Ημερομηνία",
  todo_time: "Ώρα",
  todo_date_hint: "Αφήστε κενό για χρήση ημερομηνίας/ώρας αρχικού μηνύματος",
  todo_created_success: "Η εργασία δημιουργήθηκε επιτυχώς",
  todo_creation_failed: "Αποτυχία δημιουργίας εργασίας",
  create: "Δημιουργία",
  
  image: "εικόνα",
  images: "εικόνες",
  remove_all_images: "Αφαίρεση όλων των εικόνων",
  remove_image: "Αφαίρεση εικόνας",
  remove_document: "Αφαίρεση εγγράφου",
  remove_recording: "Αφαίρεση ηχογράφησης",
  play_recording: "Αναπαραγωγή ηχογράφησης",
  upload_image: "Ανέβασμα εικόνας",
  upload_document: "Ανέβασμα εγγράφου",
  record_audio: "Ηχογράφηση ήχου",
  stop_recording: "Διακοπή ηχογράφησης",
  stop_recording_text: "Διακοπή ηχογράφησης",
  please_remove_current_attachment: "Παρακαλώ αφαιρέστε το τρέχον συνημμένο για",
  please_upload_image_file: "Παρακαλώ ανεβάστε ένα έγκυρο αρχείο εικόνας",
  please_upload_valid_document: "Παρακαλώ ανεβάστε ένα έγκυρο αρχείο εγγράφου",
  searching_messages: "Αναζήτηση μηνυμάτων...",
  loading_more: "Φόρτωση περισσότερων...",
  loading_more_users: "Φόρτωση περισσότερων χρηστών...",
  load_more_users: "Φόρτωση περισσότερων χρηστών",
  no_more_users_to_load: "Δεν υπάρχουν περισσότεροι χρήστες προς φόρτωση",
  no_messages_found: "Δεν βρέθηκαν μηνύματα",
  try_different_keyword: "Δοκιμάστε μια διαφορετική λέξη-κλειδί ή ελέγξτε την ορθογραφία σας.",
  search_messages: "Αναζήτηση μηνυμάτων, ομάδων συνομιλίας, έργων και χρηστών...",
  todo: "Εργασία",
  np_todo: "Χωρίς εργασίες",
  move_to_todo: "Αποθήκευση ως εργασία",
  remove_todo: "Θέλετε πραγματικά να αφαιρέσετε την εργασία;",
  remove_all_todo: "Αφαίρεση όλων των εργασιών",
  remove_all_todo_confirm: "Θέλετε πραγματικά να αφαιρέσετε όλες τις εργασίες;",
  add_to_todo: "Προσθήκη στην εργασία",
  remove_from_todo: "Αφαίρεση από εργασία",
  confirm: "Επιβεβαίωση",
  ok: "Εντάξει",
  read_more: "Διαβάστε περισσότερα",
  show_less: "Εμφάνιση λιγότερων",
  show_more: "Εμφάνιση περισσότερων",
  audio: "Ήχος",
  video: "Βίντεο",
  // Notification Settings
  notification_schedule: "Πρόγραμμα ειδοποιήσεων",
  notification_schedule_desc: "Θα λαμβάνετε push και email ειδοποιήσεις μόνο στις ώρες που επιλέγετε. Εκτός αυτών των ωρών θα παύσουν.",
  learn_more: "Μάθετε περισσότερα",
  allow_notifications: "Επιτρέψτε ειδοποιήσεις:",
  every_day: "Κάθε ημέρα",
  weekdays: "Εργάσιμες (Δευτέρα έως Παρασκευή)",
  custom: "Προσαρμοσμένο",
  monday: "Δευτέρα",
  tuesday: "Τρίτη",
  wednesday: "Τετάρτη",
  thursday: "Πέμπτη",
  friday: "Παρασκευή",
  saturday: "Σάββατο",
  sunday: "Κυριακή",
  to: "έως",
  notification_settings: "Ειδοποιήσεις",
  notification_settings_saved: "Οι ρυθμίσεις ειδοποιήσεων αποθηκεύτηκαν επιτυχώς",
  notification_settings_error: "Αποτυχία αποθήκευσης ρυθμίσεων ειδοποιήσεων",
  unavailability_note: "Σημείωση απουσίας",
  unavailability_description: "Ορίστε μια σημείωση απουσίας. Όσο είναι ενεργή, η σημείωση εμφανίζεται στους άλλους σε όλες τις συνομιλίες σας και οι ειδοποιήσεις τίθενται σε παύση.",
  unavailability_start_date: "Ημερομηνία έναρξης",
  unavailability_end_date: "Ημερομηνία λήξης",
  unavailability_message: "Μήνυμα",
  unavailability_message_hint: "Χρησιμοποιήστε το {endDate} ως σύμβολο κράτησης θέσης για την ημερομηνία επιστροφής σας.",
  unavailability_replacement: "Αντικαταστάτης επικοινωνίας",
  unavailability_replacement_placeholder: "Εισαγάγετε αναγνωριστικό χρήστη για επείγοντα αιτήματα",
  unavailability_replacement_current: "Τρέχων αντικαταστάτης",
  unavailability_replacement_hint: "Εάν οριστεί, ένας σύνδεσμος για επικοινωνία με αυτό το άτομο για επείγοντα θέματα θα εμφανιστεί στη σημείωση απουσίας σας.",
  unavailability_replacement_none: "Χωρίς αντικαταστάτη (προαιρετικό)",
  unavailability_contact_urgent: "Για επείγοντα αιτήματα επικοινωνήστε με",
  unavailability_default_message: "Αυτή τη στιγμή δεν βρίσκομαι στο γραφείο και δεν έχω πρόσβαση στο Kjuup. Θα είμαι ξανά διαθέσιμος/η από {endDate} και θα επικοινωνήσω μαζί σας τότε.",
  unavailability_save: "Αποθήκευση",
  unavailability_deactivate: "Απενεργοποίηση",
  unavailability_active_until: "Ενεργό έως",
  unavailability_saved: "Η σημείωση απουσίας αποθηκεύτηκε",
  unavailability_save_error: "Αποτυχία αποθήκευσης σημείωσης απουσίας",
  unavailability_deactivated: "Η σημείωση απουσίας απενεργοποιήθηκε",
  unavailability_end_date_required: "Η ημερομηνία λήξης είναι υποχρεωτική",
  start_time_before_end_time: "Η ώρα έναρξης πρέπει να είναι πριν από την ώρα λήξης",
  loading: "Φόρτωση",
  disabled: "Απενεργοποιημένο",
  enable: "Ενεργοποίηση",
  disable: "Απενεργοποίηση",
  forwarded: "Προωθημένο",
  message_forwarded: "Το μήνυμα προωθήθηκε!",
  // Schedule Article
  schedule_article_post: "Προγραμματισμός δημοσίευσης άρθρου",
  date: "Ημερομηνία",
  time: "Ώρα",
  scheduled_for_publication: "Προγραμματισμένο για δημοσίευση",
  article_will_be_published_on: "Το άρθρο θα δημοσιευθεί στις:",
  reset_selection: "Επαναφορά επιλογής",
  continue: "Συνέχεια",
  cancel: "Ακύρωση",
  // Member Selection
  error_loading_members: "Σφάλμα φόρτωσης μελών",
  please_fill_all_fields: "Παρακαλώ συμπληρώστε όλα τα πεδία",
  invalid_email: "Μη έγκυρη διεύθυνση e-mail",
  member_added_successfully: "Το μέλος προστέθηκε επιτυχώς",
  error_onboarding_user: "Σφάλμα προσθήκης χρήστη",
  error_creating_chat: "Σφάλμα δημιουργίας συνομιλίας",
  error_creating_group: "Σφάλμα δημιουργίας ομάδας",
  new_group: "Νέα ομάδα",
  please_select_or_enter_group_name: "Παρακαλώ επιλέξτε μια ομάδα ή εισάγετε όνομα ομάδας",
  please_select_or_enter_room_name: "Παρακαλώ επιλέξτε ένα έργο ή εισάγετε όνομα έργου",
  error_creating_room: "Σφάλμα δημιουργίας έργου",
  error_opening_chat: "Σφάλμα ανοίγματος συνομιλίας",
  privacy_modal_text: "Επιλέξτε \"Ιδιωτικό\" μόνο εάν η συνομιλία δεν περιέχει σχετικό επαγγελματικό περιεχόμενο για τον διευθυντή έργου.",
  not_private: "Μη ιδιωτικό",
  private: "Ιδιωτικό",
  error_loading_groups: "Σφάλμα φόρτωσης ομάδων",
  automatic_chat_export: "Αυτόματη εξαγωγή συνομιλίας",
  automatic_chat_export_info: "Μετά την ενεργοποίηση, το ιστορικό συνομιλίας θα αποστέλλεται αυτόματα στη διεύθυνση e-mail που καθορίζεται κάθε μήνα.",
  automatic_chat_export_no_email: "Για να ενεργοποιήσετε την αυτόματη εξαγωγή συνομιλίας, πρέπει πρώτα να προσθέσετε μια διεύθυνση e-mail. Μπορείτε να προσθέσετε τη διεύθυνση e-mail σας στις προσωπικές ρυθμίσεις.",
  enter_email: "Εισάγετε e-mail",
  update: "Ενημέρωση",
  confirm: "Επιβεβαίωση",
  export_to_email: "Η εξαγωγή πηγαίνει στο ακόλουθο e-mail.",
  start_chat_button:"Νέο μήνυμα",
  matching_existing_chats: "Αντιστοιχία υπαρχουσών συνομιλιών",
  subject: "Θέμα",
  add_subject: "Προσθήκη θέματος",
  chat_subject: "Θέμα συνομιλίας:",
  set_project_room: "Ορισμός έργου",
  matching_existing_project_rooms: "Αντιστοιχία υπαρχόντων έργων",
  name_project_room: "Ονομασία έργου",
  professional_or_private: "Επαγγελματικό ή ιδιωτικό",
  professional: "Επαγγελματικό",
  privacy_modal_text_updated: "Επιλέξτε \"Ιδιωτικό\" μόνο εάν η συνομιλία δεν περιέχει σχετικό επαγγελματικό περιεχόμενο για τους διευθυντές έργου. Οι ιδιωτικές συνομιλίες δεν είναι ορατές στους διευθυντές έργου.",
  create_internal_chat: "Εξωτερική - ή εσωτερική συνομιλία;",
  internal_chat_description: "Μόνο οι υπάλληλοι της εταιρείας σας μπορούν να προστεθούν σε εσωτερικές συνομιλίες.",
  yes: "Ναι",
  no: "Όχι",
  chat_is_being_created: "Η συνομιλία δημιουργείται...",
  // Additional translations for hardcoded text
  discard_article_confirm: "Θέλετε πραγματικά να απορρίψετε τις αλλαγές σε αυτό το άρθρο;",
  please_enter_article_title: "Παρακαλώ εισάγετε πρώτα τον τίτλο του άρθρου.",
  please_add_mandatory_fields: "Παρακαλώ προσθέστε όλα τα υποχρεωτικά πεδία",
  product_label: "Προϊόν:",
  no_companies_found: "Δεν βρέθηκαν εταιρείες",
  visible_to_all_followers: "Ορατό σε όλα τα μέλη Kjuup",
  only_visible_to_employees: "Ορατό μόνο σε υπαλλήλους",
  something_went_wrong: "Κάτι πήγε στραβά, παρακαλώ δοκιμάστε ξανά",
  please_select_department: "Παρακαλώ επιλέξτε τμήμα/τοποθεσία",
  schedule: "Προγραμματισμός",
  please_select_future_date_time: "Παρακαλώ επιλέξτε μια μελλοντική ημερομηνία και ώρα για τον προγραμματισμό του άρθρου.",
  please_select_different_date_time: "Παρακαλώ επιλέξτε μια διαφορετική ημερομηνία ή ώρα για τον προγραμματισμό του άρθρου.",
  please_select_later_time: "Παρακαλώ επιλέξτε μια ώρα αργότερα από την τρέχουσα ώρα για σήμερα.",
  unpin_article: "Κατάργηση στερέωσης άρθρου",
  pin_article: "Στερέωση άρθρου",
  and: "και",
  others: "άλλοι",
  at: "στις",
  // Chat mute/unmute translations
  mute: "Σίγαση",
  unmute: "Κατάργηση σίγασης",
  chat_muted_successfully: "Η συνομιλία σιγήθηκε επιτυχώς",
  chat_unmuted_successfully: "Η σίγαση συνομιλίας καταργήθηκε επιτυχώς",
  mute_chat_confirm: "Θέλετε πραγματικά να σιγήσετε αυτή τη συνομιλία; Δεν θα λαμβάνετε πλέον ειδοποιήσεις για νέα μηνύματα.",
  unmute_chat_confirm: "Θέλετε πραγματικά να καταργήσετε τη σίγαση αυτής της συνομιλίας; Θα λαμβάνετε ξανά ειδοποιήσεις για νέα μηνύματα.",
  please_select_group_to_forward: "Παρακαλώ επιλέξτε ομάδα για προώθηση μηνύματος",
  // Company translations
  record_not_found: "Η εγγραφή δεν βρέθηκε!",
  please_select_position: "Παρακαλώ επιλέξτε θέση",
  delete_article_confirm: "Είστε σίγουροι ότι θέλετε να διαγράψετε αυτό το άρθρο;",
  delete_company_service_confirm: "Είστε σίγουροι ότι θέλετε να διαγράψετε την υπηρεσία της εταιρείας;",
  block_translation_confirm: "Θέλετε πραγματικά να αποκλείσετε την αυτόματη μετάφραση σε έργα για όλα τα μέλη της εταιρείας",
  unblock_translation_confirm: "Θέλετε πραγματικά να καταργήσετε τον αποκλεισμό αυτόματης μετάφρασης σε έργα για όλα τα μέλη της εταιρείας",
  please_select_file: "Παρακαλώ επιλέξτε ένα αρχείο για ανέβασμα",
  role_in_building_industry: "Ρόλος στη βιομηχανία κατασκευών*",
  invalid_email_address: "Μη έγκυρη διεύθυνση e-mail",
  please_enter_password: "Παρακαλώ εισάγετε κωδικό",
  password_change_email_sent: "Ένα email στάλθηκε στο email σας Kjuup. Επιβεβαιώστε τον νέο κωδικό σας κάνοντας κλικ στον σύνδεσμο επιβεβαίωσης στο email.",
  please_enter_username: "Παρακαλώ εισάγετε όνομα χρήστη",
  username_same_as_before: "Το όνομα χρήστη δεν μπορεί να είναι το ίδιο με πριν",
  profile_deleted_successfully: "Το προφίλ διαγράφηκε επιτυχώς",
  hardware_requirements: "Απαιτήσεις υλικού",
  hardware_requirements_list: "• 4GB RAM<br/>• Ταχύτητα CPU ελάχ. 2GHz<br/>• Windows 7 ή νεότερο / όλες οι εκδόσεις macOS",
  submitting: "Υποβολή...",
  signing_in: "Σύνδεση...",
  please_enter_service_name: "Παρακαλώ εισάγετε όνομα υπηρεσίας",
  something_went_wrong_error: "Ααα! Κάτι πήγε στραβά...",
  something_went_wrong_try_again: "Συγγνώμη, κάτι πήγε στραβά εκεί. Δοκιμάστε ξανά",
  position_label: "Θέση:",
  loading_room: "Φόρτωση έργου...",
  navigating_to_room: "Πλοήγηση στο έργο",
  loading_chat: "Φόρτωση συνομιλίας...",
  translate: "Μετάφραση",
  show_original: "Εμφάνιση πρωτότυπου",
  saving: "Αποθήκευση...",
  language_selection_info: "Η επιλογή γλώσσας χρησιμοποιείται για όλες τις επιβεβαιώσεις e-mail σχετικά με την εταιρεία.",
  // Navigation bar labels
  nav_call: "Κλήση",
  nav_home: "Αρχική",
  nav_messages: "Μηνύματα",
  nav_todo: "εργασίες",
  nav_rooms: "Έργα",
  nav_all_rooms: "Όλα τα έργα",
  pinned_rooms_max: "Μπορείτε να καρφιτσώσετε έως 10 έργα.",
  pinned_room_unpin: "Ξεκαρφίτσωμα",
  pinned_rooms_drop: "Σύρετε το έργο σας εδώ για γρήγορη επιλογή",
  nav_profile: "Προφίλ",
  nav_company: "Εταιρεία",
  nav_company_documents: "Έγγραφα",
  nav_logout: "Αποσύνδεση",
  // Create message dialog
  add_member_title: "Προσθήκη μέλους",
  continue_btn: "Συνέχεια",
  search_placeholder: "Αναζήτηση",
  no_members_found: "Δεν βρέθηκαν μέλη",
  no_groups_found: "Δεν βρέθηκαν ομάδες",
  no_rooms_found: "Δεν βρέθηκαν έργα",
  search_users_tab: "Χρήστες",
  search_documents_tab: "Έγγραφα",
  company_documents: "Company documents",
  company_documents_empty: "No documents available.",
  no_media_available: "Δεν υπάρχουν αρχεία",
  no_documents_available: "No documents",
  searching_users: "Αναζήτηση χρηστών...",
  no_users_found: "Δεν βρέθηκαν χρήστες",
  search_emails_tab: "Email",
  searching_emails: "Αναζήτηση email...",
  no_emails_found: "Δεν βρέθηκαν email",
  search_email_addresses_tab: "E-Mail Addresses",
  search_email_content_tab: "E-Mail Content",
  searching_email_content: "Searching email content...",
  no_email_content_found: "No email content found",
  search_email_attachments_tab: "E-Mail Attachments",
  searching_email_attachments: "Searching attachments...",
  no_email_attachments_found: "No attachment matches found",
  email_attachments_label: "Attachments",  searching_email_addresses: "Searching addresses...",
  no_email_addresses_found: "No address matches found",
  email_subject_label: "Subject",
  email_body_label: "Body",
  email_address_received: "Received",
  email_address_sent: "Sent",
  unnamed_group: "Ομάδα χωρίς όνομα",
  unnamed_room: "Έργο χωρίς όνομα",
  all_members: "Όλα",
  room_label: "Έργο:",
  subject_label: "Θέμα:",
  no_members: "Χωρίς μέλη",
  // Loading states for room creation
  creating_structure: "Δημιουργία της δομής σας",
  opening_chat: "Άνοιγμα της συνομιλίας",
  please_wait: "Παρακαλώ περιμένετε...",
  // ToDo page translations
  loading_todo: "Φόρτωση ToDo...",
  task_updated: "Η εργασία ενημερώθηκε",
  error_updating_task: "Σφάλμα ενημέρωσης εργασίας",
  task_deleted: "Η εργασία διαγράφηκε",
  error_deleting_task: "Σφάλμα διαγραφής εργασίας",
  delete_task_confirm: "Είστε σίγουροι ότι θέλετε να διαγράψετε αυτή την εργασία;",
  description_label: "Περιγραφή",
  description_placeholder: "Εισάγετε περιγραφή...",
  date_time_label: "Ημερομηνία και ώρα",
  save_hint: "Ctrl+Enter για αποθήκευση, Esc για ακύρωση",
  edit_label: "Επεξεργασία",
  delete_label: "Διαγραφή",
  todo_list_title: "εργασίες",
  tasks_count: "εργασίες",
  search_placeholder_todo: "Αναζήτηση...",
  select_task_to_open_chat: "Επιλέξτε μια εργασία για να ανοίξετε τη συνομιλία",
  today: "Σήμερα",
  yesterday: "Χθες",
  time_suffix: "", // Empty for Greek (24h format doesn't need suffix)
  from_chat: "Πηγαία εργασία",
  assigned_to: "Ανατεθέν σε",
  assign_users: "Ανάθεση χρηστών",
  no_users_assigned: "Δεν έχουν ανατεθεί χρήστες",
  assign: "Ανάθεση",
  assign_to: "Ανάθεση σε...",
  navigate_to_chat: "Πλοήγηση στη συνομιλία",
  navigate_to_email: "Μετάβαση στο email",
  show_original_message: "Εμφάνιση πηγής",
  hide_original_message: "Απόκρυψη πηγής",
  status_pending: "Εκκρεμεί",
  status_in_progress: "Σε εξέλιξη",
  status_completed: "Ολοκληρώθηκε",
  show: "Εμφάνιση",
  close: "Κλείσιμο",
  // Log translation strings
  status_confirmed: "[Επιβεβαιώθηκε]",
  log_todo_created: "Εργασία [δημιουργήθηκε]",
  log_todo_confirmed: "Εργασία [επιβεβαιώθηκε]",
  log_todo_deleted: "Εργασία [διαγράφηκε]",
  log_todo_updated: "Εργασία [ενημερώθηκε]",
  log_description_updated: "[Περιγραφή ενημερώθηκε]",
  log_deadline_updated: "[Προθεσμία ενημερώθηκε]",
  log_assigned_to: "[Ανατέθηκε σε] {name}",
  log_unassigned_from: "[Αναίρεση ανάθεσης από] {name}",
  log_assignment_added: "[Ανάθεση προστέθηκε]: {name}",
  log_assignment_removed: "[Ανάθεση αφαιρέθηκε]: {name}",
  log_status_updated: "[Κατάσταση άλλαξε από] {from} [σε] {to}",
  log_status_changed: "[Κατάσταση άλλαξε]",
  log_status_changed_to: "[Κατάσταση άλλαξε σε] {status}",
  log_changed_status_to: "[Άλλαξε κατάσταση σε]:",
  log_for_user: "[για χρήστη]:",
  log_user_updated_status: "[Ο χρήστης ενημέρωσε την κατάσταση εργασίας του]",
  log_changed_date_to: "[Άλλαξε ημερομηνία σε]:",
  log_changed_description_to: "[Άλλαξε περιγραφή σε]:",
  log_moved_to: "[Μετακινήθηκε σε] {status}",
  todo_status_updated_from: "[από]",
  todo_status_updated_to: "[σε]",
  filter_pending: "Εκκρεμεί",
  filter_confirmed: "Επιβεβαιωμένο",
  filter_assigned_to_me: "Οι εργασίες μου",
  filter_assigned_by_me: "Ανατεθειμένο",
  todo_project_label: "Έργο:",
  assigned_users: "Ανατεθειμένοι χρήστες:",
  todo_chat_label: "Συνομιλία:",
  history: "Ιστορικό",
  todo_assigned_by: "Ανατέθηκε από:",
  todo_assigned_push: "Ανατέθηκε ToDo:",
  todo_assigned_push_empty: "Σας ανατέθηκε ένα νέο ToDo.",
  search_groups: "Ομάδες",
  search_chat_groups: "Ομάδες συνομιλιών",
  search_project_room: "Έργο",
  search_messages_tab: "Μηνύματα",
  searching_groups: "Αναζήτηση ομάδων...",
  searching_rooms: "Αναζήτηση έργων...",
  no_groups_found: "Δεν βρέθηκαν ομάδες",
  no_rooms_found: "Δεν βρέθηκαν έργα",
  create_poll: "Ψηφοφορία",
  poll_question_label: "ΕΡΩΤΗΣΗ",
  poll_question_placeholder: "Κάντε μια ερώτηση",
  poll_options_label: "ΕΠΙΛΟΓΕΣ",
  poll_option: "Επιλογή",
  poll_add_option: "Προσθήκη επιλογής",
  poll_allow_multiple: "Να επιτρέπονται πολλές απαντήσεις",
  poll_multiple_allowed: "Επιλέξτε μία ή περισσότερες επιλογές",
  poll_select_option: "Επιλέξτε μία επιλογή",
  poll_view_votes: "Δείτε ψήφους",
  poll_vote_singular: "ψήφος",
  poll_vote_plural: "ψήφοι",
  poll_votes: "Αποτελέσματα ψηφοφορίας",
  poll_no_votes_yet: "Δεν υπάρχουν ακόμα ψήφοι",
  transcript_step_processing: "Μεταγραφή σε εξέλιξη...",
  ai_transcript_tab: "AI-Μεταγραφή",
  ai_transcript_info: "Διαθέσιμο μόνο για φωνητικά μηνύματα που δημιουργήθηκαν μετά τις 09.03.2026.",
  transcript_more: "...περισσότερα",
  transcript_less: "...λιγότερα",
  ki_transcript_voice_message: "KI-Μεταγραφή φωνητικού μηνύματος",
  ki_image_analysis: "Ανάλυση εικόνας με υποστήριξη AI",
  type_message: "Πληκτρολογήστε ένα μήνυμα",
  email_tab_messages: "Μηνύματα",
  email_tab_email: "E-mail",
  email_tab_messages_and_email: "Messages & E-Mail",
  email_tab_email_details: "E-Mail Details",
  email_accounts: "Λογαριασμοί e-mail",
  email_connect_gmail: "Σύνδεση Gmail",
  email_connect_outlook: "Σύνδεση Outlook",
  email_no_accounts: "Δεν υπάρχουν συνδεδεμένοι λογαριασμοί e-mail",
  email_no_accounts_hint: "Συνδέστε λογαριασμό e-mail στις ρυθμίσεις προφίλ",
  email_no_messages: "Δεν υπάρχουν e-mails",
  email_from: "Από",
  email_to: "Προς",
  email_subject: "Θέμα",
  email_disconnect: "Αποσύνδεση",
  email_disconnect_confirm: "Είστε σίγουροι ότι θέλετε να αποσυνδέσετε αυτόν τον λογαριασμό email; Όλα τα συγχρονισμένα email θα αφαιρεθούν.",
  email_account_disconnected: "Ο λογαριασμός email αποσυνδέθηκε επιτυχώς",
  email_account_disconnect_failed: "Αποτυχία αποσύνδεσης λογαριασμού",
  email_connecting: "Σύνδεση...",
  email_account_connected: "Ο λογαριασμός συνδέθηκε με επιτυχία",
  email_signature: "Signature",
  email_signature_placeholder: "Enter your email signature...",
  email_signature_save: "Save",
  email_signature_saved: "Saved",
  email_go_to_settings: "Μετάβαση στις ρυθμίσεις",
  email_date: "Ημερομηνία",
  email_reply: "Απάντηση",
  email_forward: "Προώθηση",
  email_copy_text: "Αντιγραφή κειμένου",
  email_text_copied: "Αντιγράφηκε!",
  email_text_copy_failed: "Δεν ήταν δυνατή η αντιγραφή του κειμένου.",
  email_delete: "Διαγραφή",
  email_not_spam: "Δεν είναι spam",
  email_not_spam_success: "Το email μεταφέρθηκε στα εισερχόμενα.",
  email_not_spam_failed: "Αποτυχία μεταφοράς στα εισερχόμενα.",
  email_delete_confirm: "Είστε σίγουροι ότι θέλετε να διαγράψετε αυτό το email;",
  email_delete_from_folder: "Είστε σίγουροι ότι θέλετε να διαγράψετε από {folder};",
  email_delete_permanent_from_folder:
    "Είστε σίγουροι ότι θέλετε να διαγράψετε οριστικά από {folder}; Αυτή η ενέργεια δεν μπορεί να αναιρεθεί.",
  email_save_draft_confirm: "Θέλετε να αποθηκεύσετε αυτό το email ως πρόχειρο;",
  email_save_draft: "Αποθήκευση προχείρου",
  email_discard: "Απόρριψη",
  email_back_to_compose: "Επιστροφή στη σύνταξη",
  email_draft_saved: "Το πρόχειρο αποθηκεύτηκε.",
  email_draft_save_failed: "Αποτυχία αποθήκευσης προχείρου.",
  email_loading: "Φόρτωση e-mails...",
  email_archived: "Archived",
  email_mark_spam: "Mark as spam",
  email_marked_spam: "Marked as spam",
  email_group_today: "Today",
  email_group_yesterday: "Yesterday",
  email_group_this_week: "This week",
  email_group_earlier: "Earlier",
  email_search: "Search",
  email_search_placeholder: "Search mail",
  email_no_results: "No matching messages",
  email_clear_search: "Clear search",
  email_star: "Star",
  email_unstar: "Unstar",
  email_starred: "Starred",
  email_folder_starred: "Starred",
  email_select: "Επιλογή",
  email_attachment_singular: "Συνημμένο",
  email_attachment_plural: "Συνημμένα",
  email_back: "Πίσω",
  email_download: "Λήψη",
  email_close: "Κλείσιμο",
  email_preview: "Προεπισκόπηση",
  email_preview_not_available: "Η προεπισκόπηση δεν είναι διαθέσιμη",
  email_preview_failed: "Η προεπισκόπηση δεν είναι διαθέσιμη",
  select_attachments: "Επιλογή συνημμένων",
  email_loading_preview: "Φόρτωση προεπισκόπησης...",
  email_mark_unread_failed: "email δεν μπόρεσαν να σημειωθούν ως μη αναγνωσμένα.",
  email_delete_failed: "email δεν μπόρεσαν να διαγραφούν.",
  filter_all: "Όλα",
  filter_email: "E-Mail",
  filter_kjuup_messages: "Kjuup",
  filter_direct_messages: "Άμεσα μηνύματα",
  my_notes: "My Space",
  filter_internal_groups: "Εσωτερικές ομαδικές συνομιλίες",
  filter_external_groups: "Εξωτερικές ομαδικές συνομιλίες",
  filter_group_chats: "Ομαδικές συνομιλίες",
  filter_groups_internal: "Εσωτερικές",
  filter_groups_external: "Εξωτερικές",
  filter_unread_only: "Μόνο αδιάβαστα",
  room_daily_briefing_info: "Όταν είναι ενεργοποιημένο, δημιουργείται αναφορά για αυτό το έργο κάθε 24 ώρες την ώρα που ορίζεται στις προσωπικές ρυθμίσεις — αλλά μόνο εάν υπήρξε δραστηριότητα κατά την περίοδο αυτή.",
  email_select_all: "Επιλογή όλων",
  email_deselect_all: "Αποεπιλογή όλων",
  email_reply_all: "Απάντηση σε όλους",
  email_reply_placeholder: "Πληκτρολογήστε την απάντησή σας...",
  email_forward_placeholder: "Προσθέστε ένα μήνυμα...",
  email_edit_draft: "Επεξεργασία πρόχειρου",
  email_attach: "Επισύναψη",
  email_attachment_from_original: "Από το αρχικό μήνυμα",
  email_remove: "Αφαίρεση",
  email_drop_files: "Σύρετε αρχεία για επισύναψη",
  email_loading_attachments: "Φόρτωση συνημμένων...",
  email_archive: "Αρχειοθέτηση",
  mark_unread: "Σημείωση ως μη αναγνωσμένο",
  mark_read: "Σημείωση ως αναγνωσμένο",
  email_all_accounts: "Όλοι οι λογαριασμοί",
  email_error: "Σφάλμα",
  email_delete_email_failed: "Αποτυχία διαγραφής email.",
  enter_url: "Εισαγάγετε URL",

  // ─── Kjuup subscription ───────────────────────────────────────────
  kjuup_io: 'Kjuup.io',
  kjuup_io_manage_subscription: 'Manage your subscription',
  kjuup_io_subscribe_now: 'Εγγραφή τώρα',
  kjuup_io_hero_subtitle: 'Upgrade to unlock premium features and get more out of every project.',
  kjuup_io_trial_badge: '1 ΜΗΝΑΣ ΔΩΡΕΑΝ ΔΟΚΙΜΗ',
  kjuup_io_trial_title: 'Unlock Kjuup.io Premium',
  kjuup_io_trial_subtitle: 'Connect your email, receive AI-powered smart replies and synchronize your tasks with your calendar.',
  kjuup_io_trial_no_payment: 'No payment today.',
  kjuup_io_trial_trust: 'Καμία πληρωμή σήμερα. Δεν ζητούνται στοιχεία πιστωτικής κάρτας πριν ξεκινήσει η επί πληρωμή συνδρομή.',
  kjuup_io_after_trial_monthly: 'After trial: {price}/month',
  kjuup_io_after_trial_yearly: 'After trial: {price}/year',
  kjuup_io_price_per_month: '{price}/month',
  kjuup_io_price_per_year: '{price}/year',
  kjuup_io_start_free_trial: 'Start free now � no risk',
  kjuup_io_trial_footnote: 'No payment today. Then {price}. Cancel anytime.',
  kjuup_io_feature_email: 'Διαχειριστείτε όλους τους λογαριασμούς email απευθείας στο Kjuup',
  kjuup_io_feature_assign: 'Automatically assign emails and attachments to projects',
  kjuup_io_feature_ai: 'Η τεχνητή νοημοσύνη γράφει απαντήσεις – εσείς απλώς επιβεβαιώνετε',
  kjuup_io_feature_tasks: 'Εργασίες και ημερολόγιο πάντα αυτόματα ενημερωμένα',
  kjuup_io_choose_plan: 'Επιλέξτε πρόγραμμα',
  kjuup_io_plan_monthly: 'Μηνιαίο',
  kjuup_io_plan_yearly: 'Ετήσιο',
  kjuup_io_plan_monthly_desc: 'Billed monthly · cancel anytime',
  kjuup_io_plan_yearly_desc: 'Save {pct}% with annual booking',
  kjuup_io_save_badge: 'SAVE {pct}%',
  kjuup_io_per_month_annual: '{price} / month · Save {pct}% with annual booking',
  kjuup_io_subscribe: 'Subscribe',
  kjuup_io_secured_stripe: 'Ασφάλεια μέσω Stripe · ακύρωση ανά πάσα στιγμή',
  kjuup_io_your_subscription: 'YOUR SUBSCRIPTION',
  kjuup_io_status_active: 'ACTIVE',
  kjuup_io_status_cancels_soon: 'CANCELS SOON',
  kjuup_io_status_switch_scheduled: 'SWITCH SCHEDULED',
  kjuup_io_label_plan: 'Plan',
  kjuup_io_label_price: 'Price',
  kjuup_io_label_status: 'Status',
  kjuup_io_label_renews: 'Renews on',
  kjuup_io_label_access_until: 'Access until',
  kjuup_io_switching_to: 'Switching to {plan} on {date}',
  kjuup_io_cancel_pending_note: 'Your subscription is set to cancel and won\'t renew. You keep access until the date above.',
  kjuup_io_resume: 'Resume subscription',
  kjuup_io_switch_to_plan: 'Switch to {plan} plan',
  kjuup_io_undo_switch: 'Undo scheduled change',
  kjuup_io_cancel_subscription: 'Cancel subscription',
  kjuup_io_switch_modal_title: 'Switch to {plan} plan?',
  kjuup_io_billed_yearly: 'Billed yearly',
  kjuup_io_billed_monthly: 'Billed monthly',
  kjuup_io_switch_modal_note: 'Starts on {date}, when your current {plan} plan ends. No charge today — you keep your current plan until then.',
  kjuup_io_confirm_switch: 'Confirm switch',
  kjuup_io_not_now: 'Not now',
  kjuup_io_cancel_modal_title: 'Cancel subscription?',
  kjuup_io_cancel_modal_note: 'You\'ll keep access to Kjuup.io until the end of your current billing period. After that it won\'t renew.',
  kjuup_io_cancel_modal_note_with_date: 'You\'ll keep access to Kjuup.io until the end of your current billing period ({date}). After that it won\'t renew.',
  kjuup_io_cancel_plan: 'Cancel plan',
  kjuup_io_keep_subscription: 'Keep my subscription',
  kjuup_io_toast_payment_failed: 'Payment failed',
  kjuup_io_toast_activating: 'Η πληρωμή ελήφθη. Η συνδρομή σας ενεργοποιείται…',
  kjuup_io_toast_activating_soon: 'Η πληρωμή ελήφθη. Η συνδρομή σας θα ενεργοποιηθεί σύντομα.',
  kjuup_io_toast_cancel_period: 'Your subscription will cancel at the end of the period',
  kjuup_io_toast_cancel_fail: 'Unable to cancel subscription',
  kjuup_io_toast_switch_scheduled: 'You\'ll move to the {plan} plan when your current period ends',
  kjuup_io_toast_switch_fail: 'Unable to switch plan',
  kjuup_io_toast_resumed: 'Your subscription will keep renewing',
  kjuup_io_toast_resume_fail: 'Unable to resume subscription',
  kjuup_io_toast_undo: 'Scheduled plan change canceled',
  kjuup_io_toast_undo_fail: 'Unable to cancel the scheduled change',
  kjuup_io_email_locked_body: 'Email is part of Kjuup.io. Activate a plan to use the Email tab.',
  kjuup_io_connect_email: 'Connect email with Kjuup.io',
  kjuup_io_activate_to_connect_email: 'Activate Kjuup.io to connect email accounts',

  kjuup_io_trial_no_card: 'No credit card details are requested before your paid subscription starts.',
  kjuup_io_status_trialing: 'TRIAL',
  kjuup_io_trial_days_left: '{days} days left in your free trial',
  kjuup_io_trial_left_hours: 'Απομένουν {count} ώρες',
  kjuup_io_trial_left_hour: 'Απομένει 1 ώρα',
  kjuup_io_trial_left_minutes: 'Απομένουν {count} λεπτά',
  kjuup_io_trial_left_minute: 'Απομένει 1 λεπτό',
  kjuup_io_trial_left_seconds: 'Απομένουν {count} δευτερόλεπτα',
  kjuup_io_trial_left_second: 'Απομένει 1 δευτερόλεπτο',
  kjuup_io_trial_ending_now: 'Η δοκιμή σας λήγει…',
  kjuup_io_request_timeout: 'Το χρονικό όριο σύνδεσης έληξε. Δοκιμάστε ξανά.',
  kjuup_io_info_days_free: '{days} ημέρες εντελώς δωρεάν – η συνδρομή ξεκινά μόνο μετά τη δοκιμή.',
  kjuup_io_discount_total: 'Η έκπτωσή σας: {percent}%',
  kjuup_io_discount_company: '{company}: {percent}%',
  kjuup_io_discount_personal: 'Προσωπική: {percent}%',
  kjuup_io_trial_ends_tomorrow: 'Your free trial ends tomorrow',
  kjuup_io_trial_ends_today: 'Your free trial ends today',
  kjuup_io_banner_dismiss: 'Κλείσιμο',
  kjuup_io_billing_after_trial: 'You\'ll be charged after your trial ends on {date}.',
  kjuup_io_trial_ended_title: 'Η δωρεάν δοκιμαστική σας περίοδος έληξε',
  kjuup_io_trial_ended_body: 'Γίνετε συνδρομητής του Kjuup.io για να συνεχίσετε να χρησιμοποιείτε το email και άλλες premium λειτουργίες.',
  kjuup_io_subscribe_to_continue: 'Subscribe now to continue',
  kjuup_io_trial_active_title: 'You\'re on a free trial',
  kjuup_io_trial_active_subtitle: 'Choose a plan and subscribe — billing starts when your trial ends.',
  kjuup_io_toast_trial_started: 'Η δωρεάν δοκιμαστική σας περίοδος ξεκίνησε',
  kjuup_io_toast_trial_fail: 'Δεν ήταν δυνατή η έναρξη της δοκιμαστικής περιόδου',
  kjuup_io_trial_try_month: 'Try Kjuup.io free for one month.',
  kjuup_io_per_month: 'per month',
  kjuup_io_price_month_line: '{price} / μήνα',
  kjuup_io_save_amount_year: 'Εξοικονομήστε {price} ανά έτος',
  kjuup_io_billed_annually_amount: '{price} χρεώνονται ετησίως',
  kjuup_io_save_yearly: 'Save {pct}% with yearly billing.',
  kjuup_io_savings_pct: '{pct}% savings',
  kjuup_io_features_title: 'Τι λαμβάνετε:',
  kjuup_io_info_one_month_free: 'One month free',
  kjuup_io_info_plan_after_trial: 'Your selected subscription starts after the trial.',
  kjuup_io_info_cancel_trial: 'Cancel anytime during the trial.',
  kjuup_io_info_no_card: 'Δεν απαιτείται πιστωτική κάρτα – ξεκινήστε αμέσως χωρίς στοιχεία πληρωμής.',
  kjuup_io_info_cancel_anytime: 'Ακύρωση οποιαδήποτε στιγμή – χωρίς δέσμευση, χωρίς ρίσκο.',
  kjuup_io_cta_plan_begins: 'Your selected plan begins after the free trial.',
  kjuup_io_billing_period_aria: 'Περίοδος χρέωσης',
  kjuup_io_subscription_info_title: 'Subscription information',
  kjuup_io_first_payment_on: 'First payment on {date}.',
  kjuup_io_renews_on: 'Renews on {date}.',
  kjuup_io_toast_card_saved: 'Ο τρόπος πληρωμής αποθηκεύτηκε. Η χρέωση θα γίνει στο τέλος της δοκιμαστικής περιόδου.',
  calendar_sync_info: 'Συγχρονίστε αυτόματα όλα τα ToDo του Kjuup με το ημερολόγιό σας.',
  calendar_no_accounts: 'Δεν έχει συνδεθεί ακόμη ημερολόγιο.',
  article_new_badge: 'ΝΕΟ',
  article_new_posts: '{0} νέες δημοσιεύσεις',
  documents: 'Έγγραφα',
  add_documents: 'Προσθήκη εγγράφων',
  no_preview_available: 'Δεν υπάρχει διαθέσιμη προεπισκόπηση',
  no_preview_hint: 'Αυτός ο τύπος αρχείου δεν μπορεί να προβληθεί σε προεπισκόπηση, αλλά θα σταλεί κανονικά.',
  max_documents_reached: 'Μπορείτε να επισυνάψετε έως 10 έγγραφα κάθε φορά.',
  open_file: 'Άνοιγμα αρχείου',
  twofa_title: 'Έλεγχος δύο παραγόντων',
  twofa_method_totp: 'Εφαρμογή ελέγχου ταυτότητας',
  twofa_method_sms: 'SMS',
  twofa_method_email: 'Email',
  twofa_enter_app: 'Εισάγετε τον 6ψήφιο κωδικό από την εφαρμογή σας.',
  twofa_enter_sms: 'Εισάγετε τον 6ψήφιο κωδικό που στείλαμε με SMS.',
  twofa_enter_email: 'Εισάγετε τον 6ψήφιο κωδικό που στείλαμε στο email σας.',
  twofa_resend: 'Αποστολή ξανά',
  twofa_try_another: 'Δοκίμασε άλλη μέθοδο',
  twofa_remember_device: 'Να μην ερωτηθώ σε αυτή τη συσκευή για 30 ημέρες',
  twofa_sent: 'Στείλαμε έναν κωδικό.',
  twofa_invalid_code: 'Αυτός ο κωδικός είναι λάθος. Δοκίμασε ξανά.',
  twofa_something_wrong: 'Κάτι πήγε στραβά. Δοκίμασε ξανά.',
  twofa_method_unavailable: 'Αυτή η μέθοδος δεν είναι διαθέσιμη.',
  twofa_on_desc: 'Ο έλεγχος δύο παραγόντων είναι ενεργός. Θα χρειάζεσαι κωδικό σε κάθε σύνδεση.',
  twofa_off_desc: 'Πρόσθεσε ένα δεύτερο βήμα μετά τον κωδικό. Οι εφαρμογές είναι η ασφαλέστερη επιλογή.',
  twofa_methods: 'Μέθοδοι',
  twofa_on: 'Ενεργό',
  twofa_add: 'Προσθήκη',
  twofa_default_method: 'Προεπιλεγμένη μέθοδος',
  twofa_default: 'Προεπιλογή',
  twofa_turn_off: 'Απενεργοποίηση',
  twofa_disable_hint: 'Εισάγετε τον κωδικό πρόσβασης και έναν τρέχοντα κωδικό για απενεργοποίηση.',
  twofa_disable_need: 'Εισάγετε τον κωδικό πρόσβασης και έναν κωδικό επαλήθευσης.',
  twofa_code_placeholder: '6ψήφιος ή εφεδρικός κωδικός',
  twofa_send_code: 'Αποστολή κωδικού',
  twofa_primary_updated: 'Η προεπιλεγμένη μέθοδος ενημερώθηκε.',
  twofa_disabled: 'Ο έλεγχος δύο παραγόντων απενεργοποιήθηκε.',
  twofa_enabled: 'Ο έλεγχος δύο παραγόντων είναι πλέον ενεργός.',
  twofa_totp_help: 'Σάρωσε αυτό το QR με Google Authenticator, Authy ή 1Password. Μπορείς να εισάγεις το κλειδί και χειροκίνητα.',
  twofa_secret_copied: 'Το κλειδί αντιγράφηκε',
  twofa_sms_help: 'Εισάγετε τον αριθμό σε διεθνή μορφή. Θα στείλουμε έναν 6ψήφιο κωδικό με SMS.',
  twofa_email_help: 'Θα στείλουμε έναν 6ψήφιο κωδικό στο email του λογαριασμού σου.',
  twofa_backup_title: 'Εφεδρικοί κωδικοί',
  twofa_backup_help: 'Φύλαξε αυτούς τους κωδικούς μίας χρήσης σε ασφαλές μέρος. Καθένας χρησιμοποιείται μία φορά αν χάσεις το τηλέφωνο.',
  twofa_copy_codes: 'Αντιγραφή κωδικών',
  twofa_codes_copied: 'Οι εφεδρικοί κωδικοί αντιγράφηκαν',
  twofa_regenerate: 'Λήψη νέων εφεδρικών κωδικών',
  twofa_regenerate_hint: 'Αυτό αντικαθιστά τους αχρησιμοποίητους εφεδρικούς κωδικούς. Εισαγάγετε τον κωδικό πρόσβασης και έναν τρέχοντα κωδικό.',
  twofa_backup_remaining: 'Απομένουν {n} αχρησιμοποίητοι εφεδρικοί κωδικοί',
  twofa_new_codes: 'Νέοι εφεδρικοί κωδικοί',
  twofa_sms_unavailable: 'Οι κωδικοί SMS δεν είναι ακόμη διαθέσιμοι.',
  todoist_sync_title: "Todoist",
  todoist_sync_info: "Οι εργασίες Kjuup που σου έχουν ανατεθεί αντιγράφονται σε ένα έργο Kjuup στο Todoist. Οι αλλαγές στο Todoist δεν αντιγράφονται πίσω.",
  todoist_connect: "Σύνδεση Todoist",
  todoist_connected: "Το Todoist συνδέθηκε",
  todoist_connect_failed: "Η σύνδεση με το Todoist απέτυχε",
  todoist_disconnect: "Αποσύνδεση",
  todoist_disconnected: "Το Todoist αποσυνδέθηκε",
  todoist_disconnect_confirm: "Αποσύνδεση του Todoist; Οι εργασίες που υπάρχουν ήδη στο Todoist μένουν. Ο συγχρονισμός σταματά.",
  todoist_sync_now: "Συγχρονισμός τώρα",
  todoist_syncing: "Συγχρονισμός…",
  todoist_sync_done: "Ο συγχρονισμός ολοκληρώθηκε",
  todoist_sync_failed: "Ο συγχρονισμός απέτυχε",
  todoist_auth_error: "Σύνδεσε ξανά το Todoist για να συνεχίσει ο συγχρονισμός.",
  todoist_last_sync: "Τελευταίος συγχρονισμός",
  todoist_not_connected: "Το Todoist δεν είναι συνδεδεμένο",
  todoist_auth_url_failed: "Δεν ήταν δυνατό το άνοιγμα της σελίδας εξουσιοδότησης του Todoist.",
  recommend_text: "Γίνε μέλος του Kjuup για να μένεις συνδεδεμένος και να κρατάς την επικοινωνία σου οργανωμένη. Φέρε όλα τα κανάλια σου μαζί, κράτα τα μηνύματα στα σωστά έργα και ξεκίνα κάθε πρωί με μια σύνοψη και τις εργασίες σου – όλα συγχρονισμένα με τις εφαρμογές που ήδη χρησιμοποιείς. Ξεκίνα δωρεάν:",
  pro_auth_signin_title: 'Καλώς ήρθατε ξανά',
  pro_auth_signin_sub: 'Συνδεθείτε με το επαγγελματικό σας email.',
  pro_auth_email_or_username: 'Email ή όνομα χρήστη',
  pro_auth_email_placeholder: 'name@company.de',
  pro_auth_forgot_password: 'Ξεχάσατε τον κωδικό;',
  pro_auth_create_account: 'Δημιουργία λογαριασμού',
  pro_auth_show_password: 'Εμφάνιση κωδικού',
  pro_auth_hide_password: 'Απόκρυψη κωδικού',
  pro_auth_register_sub: 'Θα σας στείλουμε έναν σύνδεσμο για επιβεβαίωση του email σας.',
  pro_auth_register_plus_sub: 'Επιλέξτε όνομα χρήστη και κωδικό. Στη συνέχεια ορίζετε το PIN ασφαλείας σας.',
  pro_auth_check_credentials: 'Ελέγξτε το email και τον κωδικό σας',
  pro_news_export_pdf: 'Εξαγωγή ως PDF',
  pro_news_pdf_failed: 'Δεν ήταν δυνατή η δημιουργία του PDF.',
  pro_news_pdf_attachments: 'Συνημμένα',
  pro_news_pdf_video: 'Βίντεο',
  pro_auth_forgot_sub: 'Εισαγάγετε το email σας και θα σας στείλουμε έναν σύνδεσμο για επαναφορά του κωδικού σας.',
  pro_auth_send_link: 'Αποστολή συνδέσμου επαναφοράς',
  pro_auth_plus_reset: 'Επαναφορά με PIN',
  pro_auth_show_pin: 'Εμφάνιση PIN',
  pro_auth_hide_pin: 'Απόκρυψη PIN',
  v2_auth_plus_only: 'Μόνο Kjuup+',
  room_action_media: "Αρχεία",
  room_tab_overview: "Επισκόπηση",
  room_tab_history: "Ιστορικό",
  chat_info_media: "Αρχεία",
  messages: "μηνύματα",
  pro_todo_project_required: "Επιλέξτε ένα έργο",
  pro_todo_choose_project: "Για ποιο έργο είναι αυτή η εργασία;",
  cockpit_report_delete_confirm: "Να διαγραφεί αυτή η ημερήσια αναφορά;",
  cockpit_report_deleted: "Η ημερήσια αναφορά διαγράφηκε",
  cockpit_tab_company: "Εταιρεία",
  cockpit_bookmarked_priorities: "Αποθηκευμένες εργασίες",
  cockpit_load_error: "Δεν ήταν δυνατή η φόρτωση του Cockpit.",
  cockpit_retry: "Δοκιμάστε ξανά",
  cockpit_yesterday: "Χθες",
  cockpit_greeting_morning: "Καλημέρα",
  cockpit_greeting_day: "Καλό απόγευμα",
  cockpit_greeting_evening: "Καλησπέρα",
  cockpit_assistant_q_open: "Τι εκκρεμεί σήμερα;",
  cockpit_assistant_q_summarize: "Σύνοψη της συνομιλίας {{room}}",
  cockpit_assistant_q_overdue: "Ποιες εργασίες έχουν καθυστερήσει;",
  cockpit_assistant_new: "{{n}} νέα",
  cockpit_assistant_important: "{{n}} σημαντικά",
  cockpit_assistant_title: "Βοηθός Kjuup",
  cockpit_assistant_hint: "Πατήστε και ρωτήστε",
  room_overview_priority_no_detail: "Η αναφορά δεν παρέχει περαιτέρω λεπτομέρειες για αυτή την προτεραιότητα.",
  room_overview_priority_from: "Πηγή: {{name}}",
  room_overview_priority_open_task: "Άνοιγμα εργασίας",
  cockpit_priority_position: "{{index}} από {{total}} προτεραιότητες",
  room_overview_today_title: "Σημαντικά σήμερα",
  room_overview_all_tasks: "Όλα",
  room_overview_tasks_empty: "Δεν υπάρχουν ανοιχτές προθεσμίες ή εργασίες",
  room_overview_appointments_empty: "Δεν υπάρχουν επερχόμενα ραντεβού",
  room_overview_no_priorities: "Δεν υπάρχουν ανοιχτές προτεραιότητες στην τελευταία αναφορά.",
  cockpit_report_top5: "Top 5 προτεραιότητες",
  cockpit_report_todo_created: "Η εργασία δημιουργήθηκε",
  cockpit_report_source_missing: "Το αρχικό μήνυμα δεν βρέθηκε.",
  delete_bookmarked_priority_confirm: "Θέλετε σίγουρα να διαγράψετε αυτή την αποθηκευμένη εργασία;",
  cockpit_report_create_todo: "Δημιουργία εργασίας",
  cockpit_priorities_deleting: "Διαγραφή …",
  cockpit_priorities_select: "Διαγραφή πολλών",
  cockpit_report_none: "Δεν υπάρχουν εγγραφές.",
  cockpit_priorities_delete_confirm: "Θέλετε σίγουρα να διαγράψετε {count} αποθηκευμένες εργασίες;",
  cockpit_priorities_delete_failed: "Δεν ήταν δυνατή η διαγραφή {count} εργασιών",
  cockpit_priorities_deleted: "Διαγράφηκαν {count} εργασίες",
  cockpit_priorities_selected: "{count} επιλεγμένα",
  cockpit_channel_connected: "Συνδεδεμένο",
  cockpit_channel_not_connected: "Μη συνδεδεμένο",
  cockpit_channel_connect: "Σύνδεση",
  cockpit_channel_chat: "Συνομιλία Kjuup",
  cockpit_channel_active: "Ενεργό",
  cockpit_channel_hidden: "Κρυφό",
  cockpit_channel_enable: "Ενεργοποίηση",
  cockpit_channel_email: "Email",
  cockpit_channel_check: "Έλεγχος σύνδεσης",
  cockpit_channel_fix: "Έλεγχος",
  cockpit_channel_forward: "Διεύθυνση προώθησης",
  cockpit_channel_not_set_up: "Δεν έχει ρυθμιστεί",
  cockpit_channel_set_up: "Ρύθμιση",
  cockpit_channel_teams: "Microsoft Teams",
  cockpit_channel_broken: "Η σύνδεση χάθηκε",
  cockpit_channel_importing: "Εισαγωγή",
  cockpit_channel_removing: "Αποσύνδεση",
  cockpit_channel_reconnect: "Επανασύνδεση",
  cockpit_channels_title: "Κανάλια",
  cockpit_company_role_super_admin: "Διαχειριστής εταιρείας",
  cockpit_company_role_dept_admin: "Διαχειριστής τμήματος",
  cockpit_company_role_member: "Υπάλληλος",
  cockpit_company_none: "Δεν βρέθηκε εταιρεία Kjuup+",
  cockpit_company_eyebrow: "Εταιρεία",
  cockpit_company_inactive: "ανενεργή",
  cockpit_company_settings: "Ρυθμίσεις εταιρείας",
  cockpit_company_employees: "Υπάλληλοι",
  cockpit_company_internal_rooms: "Εσωτερικά έργα",
  cockpit_report_all_projects: "Όλα τα έργα",
  cockpit_report_progress_emails: "Ανάλυση email",
  cockpit_report_progress_chats: "Ανάλυση μηνυμάτων συνομιλίας",
  cockpit_report_progress_documents: "Ανάλυση συνημμένων και εγγράφων",
  cockpit_report_progress_tasks: "Ανάλυση εργασιών",
  cockpit_report_progress_summarizing: "Ανάλυση περιεχομένου",
  cockpit_report_progress_reading: "Επαναχρησιμοποίηση περιεχομένου που έχει ήδη αναλυθεί",
  cockpit_report_progress_collecting: "Συλλογή email, συνομιλιών και εργασιών από τα έργα σας",
  cockpit_report_progress_priorities: "Σύνταξη προτεραιοτήτων, προθεσμιών και αποφάσεων",
  cockpit_report_progress_queued: "Προετοιμασία της αναφοράς",
  cockpit_report_creating_title: "Η ημερήσια αναφορά σας ετοιμάζεται",
  cockpit_report_progress_count_one: "1 στοιχείο αναλύθηκε",
  cockpit_report_progress_count_many: "{{count}} στοιχεία αναλύθηκαν",
  cockpit_report_progress_hint: "Συνήθως διαρκεί ένα έως δύο λεπτά – στο μεταξύ μπορείτε να συνεχίσετε να χρησιμοποιείτε το Cockpit.",
  cockpit_report_time_hint: "Η ημερήσια αναφορά δημιουργείται κάθε μέρα στις {{hour}}:00 για τα πέντε πιο ενεργά έργα.",
  room_overview_priorities_title: "Τρέχουσα κατάσταση και προτεραιότητες",
  room_overview_as_of: "Από {{time}}",
  cockpit_report_delete: "Διαγραφή ημερήσιας αναφοράς",
  email_tag_daily_briefing: "Ημερήσια αναφορά",
  cockpit_report_unread: "Νέο",
  cockpit_report_clear_project: "Εμφάνιση όλων των έργων",
  cockpit_filter_project: "Έργο",
  cockpit_filter_all_projects: "Όλα τα έργα",
  cockpit_report_recreate: "Εκ νέου δημιουργία ημερήσιας αναφοράς",
  cockpit_report_hide_previous: "Απόκρυψη προηγούμενων ημερήσιων αναφορών",
  cockpit_report_show_previous: "Εμφάνιση προηγούμενων ημερήσιων αναφορών",
  cockpit_report_room_empty: "Δεν υπάρχει ακόμη ημερήσια αναφορά για αυτό το έργο",
  cockpit_report_empty: "Δεν υπάρχει ακόμη ημερήσια αναφορά",
  cockpit_report_room_empty_hint: "Δημιουργήστε μια ημερήσια αναφορά μόνο για αυτό το έργο.",
  cockpit_report_needs_mailbox: "Συνδέστε έναν λογαριασμό email ώστε το Kjuup να δημιουργεί ημερήσια αναφορά με αυτόματες εργασίες.",
  cockpit_report_create: "Δημιουργία ημερήσιας αναφοράς",
  cockpit_email_connect: "Σύνδεση email",
  cockpit_email_none_title: "Δεν έχει συνδεθεί ακόμη λογαριασμός email",
  cockpit_email_none_reports: "Συνδέστε το γραμματοκιβώτιό σας ώστε το Kjuup να αντιστοιχίζει τα εισερχόμενα email στα έργα σας και να δημιουργεί ημερήσιες αναφορές με εργασίες.",
  cockpit_email_none_client: "Συνδέστε Gmail, Outlook ή IMAP για να διαβάζετε, να αντιστοιχίζετε και να απαντάτε σε email απευθείας στο Kjuup.io.",
  cockpit_email_reports_title: "Τρέχων πρόγραμμα email",
  cockpit_email_reports_text: "Χωρίς εισερχόμενα στο Kjuup.io · {{rooms}} έργα με ημερήσια αναφορά στις {{hour}}:00 · τα εισερχόμενα email αντιστοιχίζονται στα έργα σας.",
  cockpit_email_reports_rooms: "Διαχείριση έργων",
  cockpit_email_settings: "Ρυθμίσεις email",
  cockpit_email_error_title: "Έλεγχος σύνδεσης",
  cockpit_email_client_title: "Τα εισερχόμενα συνδέθηκαν",
  cockpit_email_accounts_n: "{{n}} λογαριασμός συνδεδεμένος",
  cockpit_email_last_sync: "τελευταίος συγχρονισμός {{when}}",
  cockpit_email_report_at: "Ημερήσια αναφορά στις {{hour}}:00",
  cockpit_email_open_inbox: "Άνοιγμα εισερχομένων",
  cockpit_email_eyebrow: "Kjuup-Email",
  cockpit_email_accounts_label: "Συνδεδεμένες διευθύνσεις email",
  email_folder_sent: "Απεσταλμένα",
  email_no_subject: "(Χωρίς θέμα)",
  cockpit_email_detail_loading: "Φόρτωση email …",
  cockpit_email_detail_failed: "Δεν ήταν δυνατή η φόρτωση του email.",
  cockpit_email_detail_empty: "Αυτό το email δεν έχει κείμενο.",
  cockpit_personal_settings: "Προσωπικές ρυθμίσεις",
  cockpit_companies: "Εταιρείες",
  cockpit_title: "Cockpit",
  cockpit_back: "Πίσω στην επισκόπηση",
  cockpit_day_overview: "Η ημέρα σας με μια ματιά",
  email_saved_to_project: "Το email αποθηκεύτηκε στο έργο",
  email_classify_need_project: "Εισαγάγετε όνομα έργου",
  cockpit_email_deleted: "Το email διαγράφηκε",
  cockpit_email_sent_empty: "Δεν υπάρχουν ακόμη απεσταλμένα email.",
  cockpit_email_incoming_empty: "Δεν υπάρχουν ακόμη εισερχόμενα email.",
  cockpit_email_incoming_title: "Email",
  cockpit_email_incoming_sub: "Αντιστοιχίστε τα εισερχόμενα και τα απεσταλμένα email στα έργα σας. Εδώ μπορείτε να προσαρμόσετε την αντιστοίχιση.",
  cockpit_email_incoming_unassigned_n: "{{n}} χωρίς αντιστοίχιση",
  cockpit_email_folder_inbox: "Εισερχόμενα",
  cockpit_email_folder_sent: "Απεσταλμένα",
  cockpit_email_open: "Άνοιγμα email",
  cockpit_email_incoming_suggested: "Πρόταση: {{room}}",
  cockpit_email_incoming_apply: "Εφαρμογή",
  cockpit_email_incoming_adjust: "Προσαρμογή αντιστοίχισης",
  cockpit_email_incoming_saving: "Αποθήκευση …",
  cockpit_email_incoming_unassigned: "Χωρίς αντιστοίχιση",
  cockpit_email_incoming_show_less: "Εμφάνιση λιγότερων",
  cockpit_email_incoming_show_all: "Εμφάνιση και των {{n}}",
  cockpit_io_settings: "Ρυθμίσεις Kjuup.io",
  cockpit_io_settings_sub: "Πακέτο και θέσεις, ανάθεση υπαλλήλων, τιμολόγηση και τιμολόγια.",
  products_coming_soon: "Σύντομα διαθέσιμο",
  cockpit_upsell_io_title: "Το γραφείο σας που σκέφτεται μαζί σας",
  cockpit_upsell_io_text: "Συνδέστε τους λογαριασμούς email σας με το Kjuup. Τα email, τα συνημμένα και τα μηνύματα αποθηκεύονται αυτόματα στο αντίστοιχο έργο και προαιρετικά μπορούν να φυλάσσονται στον διακομιστή σας. Κάθε μέρα λαμβάνετε μια σύνοψη όλων των έργων με τα βασικά σημεία από όλο το περιεχόμενο, ενώ οι εργασίες σας συγχρονίζονται με το ημερολόγιο ή την εφαρμογή εργασιών σας.",
  cockpit_upsell_io_soon_title: "Δεν είναι ακόμη διαθέσιμο για αγορά",
  cockpit_upsell_io_soon_text: "Το Kjuup.io κυκλοφορεί σύντομα. Ζητήστε πληροφορίες τώρα – θα σας ενημερώσουμε μόλις μπορείτε να αγοράσετε το Kjuup.io.",
  cockpit_upsell_io_planned_price: "Προγραμματισμένη τιμή",
  cockpit_upsell_io_cta_request: "Αίτημα πληροφοριών",
  kjuup_plus_abo_per_year: "/ έτος",
  kjuup_plus_abo_per_month: "/ μήνα",
  kjuup_plus_abo_status_active: "Ενεργή",
  kjuup_plus_abo_status_requested: "Ζητήθηκε ακύρωση",
  kjuup_plus_abo_status_past_due: "Εκκρεμής πληρωμή",
  kjuup_plus_abo_eyebrow: "Kjuup+ · Συνδρομή",
  kjuup_plus_abo_title: "Πακέτο Kjuup+",
  kjuup_plus_abo_seats_free_one: "1 ελεύθερη θέση",
  kjuup_plus_abo_billing: "Τιμολόγηση",
  kjuup_plus_abo_yearly: "Ετήσια",
  kjuup_plus_abo_monthly: "Μηνιαία",
  kjuup_plus_abo_amount: "Ποσό",
  kjuup_plus_abo_ends: "Λήγει στις",
  kjuup_plus_abo_renews: "Επόμενη ανανέωση",
  kjuup_plus_abo_next_invoice: "Επόμενο τιμολόγιο",
  kjuup_plus_abo_intro: "Εισαγωγική τιμή",
  kjuup_plus_abo_pending_tier: "Από την επόμενη ανανέωση",
  kjuup_plus_abo_manual: "Το Kjuup+ είναι ενεργό για την εταιρεία σας βάσει ατομικής συμφωνίας.",
  kjuup_plus_abo_invoices: "Τιμολόγια",
  kjuup_plus_abo_invoice_paid: "Πληρωμένο",
  kjuup_plus_abo_invoice_view: "Προβολή",
  kjuup_plus_abo_invoices_less: "Εμφάνιση λιγότερων",
  kjuup_plus_abo_member_hint: "Η τιμολόγηση και η ακύρωση διαχειρίζονται από τους διαχειριστές της εταιρείας σας.",
  kjuup_plus_abo_withdraw: "Ανάκληση αιτήματος",
  kjuup_plus_abo_cancel_note: "Λόγος (προαιρετικό)",
  kjuup_plus_abo_cancel_send: "Αίτημα ακύρωσης",
  kjuup_plus_abo_cancel: "Ακύρωση συνδρομής",
  cockpit_upsell_plus_f1: "Διαχειριστείτε τη δραστηριότητα επικοινωνίας όλων των υπαλλήλων σας",
  cockpit_upsell_plus_f2: "Ενημερώστε συγκεκριμένες ομάδες χρηστών εντός της εταιρείας",
  cockpit_upsell_plus_f3: "Αποθηκεύστε εσωτερικές ομαδικές συνομιλίες",
  cockpit_upsell_plus_when_yearly: "με ετήσια πληρωμή",
  cockpit_upsell_plus_size_small: "1–50 υπάλληλοι",
  cockpit_upsell_plus_size_large: "51–200 υπάλληλοι",
  cockpit_upsell_plus_title: "Kjuup+ για εταιρείες",
  cockpit_upsell_plus_text: "Διαχειριστείτε υπαλλήλους, δικαιώματα εγγραφής και εταιρική επικοινωνία σε ένα σημείο. Τα εσωτερικά κανάλια παραμένουν στην ομάδα σας, τα εξωτερικά κανάλια σας συνδέουν με συνεργάτες έργων και μπορείτε να προσεγγίσετε συγκεκριμένες ομάδες απευθείας. Εκτός από το Kjuup+, μπορείτε να αγοράσετε πρόσβαση στο Kjuup.io για ομάδες υπαλλήλων. Το Kjuup+ και το Kjuup.io μπορούν να συνδυαστούν.",
  cockpit_upsell_plus_size: "Μέγεθος εταιρείας",
  cockpit_upsell_plus_billing: "Τιμολόγηση",
  cockpit_upsell_plus_per_company: "/ εταιρεία · μήνα χωρίς ΦΠΑ",
  cockpit_upsell_plus_onboarding: "Το κόστος ένταξης/εισαγωγής εξαρτάται από το μέγεθος της εταιρείας",
  cockpit_upsell_plus_larger: "Τιμές για μεγαλύτερες εταιρείες κατόπιν αιτήματος",
  cockpit_upsell_plus_cta: "Αίτημα χωρίς δέσμευση",
  cockpit_kpi_deadlines_tasks: "Προθεσμίες & εργασίες",
  cockpit_kpi_appointments: "Ραντεβού",
  cockpit_room_admin: "Διαχείριση έργων & συνομιλιών",
  cockpit_room_admin_sub: "Όλα τα έργα της εταιρείας με μέλη, πολυμέσα και συνομιλίες.",
  pro_todo_not_found: "Αυτή η εργασία δεν είναι πλέον διαθέσιμη.",
  cockpit_chip_overdue: "Καθυστερημένες",
  cockpit_chip_today: "Σήμερα",
  cockpit_calendar_week: "Εβδ. {{week}}",
  cockpit_prev_week: "Προηγούμενη εβδομάδα",
  cockpit_next_week: "Επόμενη εβδομάδα",
  cockpit_chip_requested: "Σε αίτημα",
  cockpit_todo_due: "Προθεσμία {{when}}",
  cockpit_todo_at: "{{time}}",
  cockpit_todo_requested_from: "από {{name}}",
  cockpit_todo_since: "από {{when}}",
  cockpit_todo_no_date: "Χωρίς ημερομηνία",
  cockpit_todo_mark_done: "Σήμανση ως ολοκληρωμένης",
  cockpit_my_tasks_title: "Οι εργασίες μου",
  cockpit_today_tasks_group: "Εργασίες σήμερα",
  cockpit_assign_none: "Δεν έχει ανατεθεί σε κανέναν",
  no_project_found: "Δεν βρέθηκε έργο",
  cockpit_row_more_actions: "Περισσότερες ενέργειες",
  needs_date: "Ορισμός ημερομηνίας",
  cockpit_assign_proposal: "Εντοπίστηκε ο/η {{name}} – να γίνει ανάθεση;",
  cockpit_assign_proposal_confirm: "Ανάθεση",
  cockpit_assign_proposal_dismiss: "Παράβλεψη",
  cockpit_priority_date: "Ημερομηνία",
  todo_calendar_add: "Προσθήκη στο ημερολόγιο",
  todo_calendar_remove: "Αφαίρεση από το ημερολόγιο",
  cockpit_todo_change_project: "Αλλαγή έργου",
  cockpit_todo_set_date: "Ορισμός ημερομηνίας",
  pro_todo_done_confirm: "Θέλετε πράγματι να σημάνετε αυτή την εργασία ως ολοκληρωμένη;",
  cockpit_task_delete_failed: "Δεν ήταν δυνατή η διαγραφή της εργασίας.",
  cockpit_setup_title: "Ολοκληρώστε τη ρύθμιση",
  cockpit_setup_text: "Αποφασίστε αν θέλετε να χρησιμοποιείτε συνομιλίες και αν το Kjuup.io θα λειτουργεί ως πρόγραμμα email ή μόνο με έργα και ημερήσιες αναφορές.",
  cockpit_setup_cta: "Ρύθμιση τώρα",
  cockpit_group_tasks: "Προθεσμίες & εργασίες",
  cockpit_group_appointments: "Ραντεβού",
  cockpit_report_no_activity: "Αυτό το έργο δεν είχε νέα μηνύματα ή email τις τελευταίες 24 ώρες.",
  cockpit_report_room_unavailable: "Αυτό το έργο δεν είναι διαθέσιμο.",
  cockpit_report_create_failed: "Δεν ήταν δυνατή η δημιουργία της ημερήσιας αναφοράς.",
  cockpit_report_created: "Η ημερήσια αναφορά δημιουργήθηκε",
  addon_enable_confirm: "Ενεργοποίηση του πρόσθετου;",
  addon_enable: "Ενεργοποίηση",
  addon_enabled: "Το πρόσθετο ενεργοποιήθηκε",
  nav_email: "Email",
  nav_my_cockpit: "Το Cockpit μου",
  nav_news: "Νέα",
  nav_recommend: "Προτείνετε",
  pro_todo_status_done: "Ολοκληρώθηκε",
  pro_todo_status_open: "Ανοιχτή",
  v2_todo_remove: "Αφαίρεση",
  pro_todo_search_people: "Αναζήτηση ατόμων",
  pro_todo_clear: "Εκκαθάριση",
  pro_todo_assigned: "(ανατεθειμένο)",
  pro_todo_no_people: "Δεν βρέθηκαν άτομα",
  pro_todo_search_rooms: "Αναζήτηση έργων",
  pro_todo_no_rooms_match: "Κανένα έργο δεν ταιριάζει με «{{q}}»",
  pro_todo_no_rooms: "Δεν βρέθηκαν έργα",
  pro_todo_activity: "Δραστηριότητα",
  pro_todo_show_less: "Εμφάνιση λιγότερων",
  pro_todo_show_all: "Εμφάνιση όλων ({{n}})",
  pro_todo_due: "Προθεσμία",
  pro_todo_room: "Έργο",
  pro_todo_select_room: "Επιλογή έργου",
  pro_todo_status: "Κατάσταση",
  pro_todo_more: "Περισσότερα",
  pro_todo_edit_title: "Επεξεργασία εργασίας",
  pro_todo_description: "Περιγραφή",
  pro_todo_created_by: "Δημιουργήθηκε από",
  pro_todo_chat: "Συνομιλία",
  navigate_to_source: "Μετάβαση στην πηγή",
  todo_calendar_connect_title: "Δεν υπάρχει συνδεδεμένο ημερολόγιο",
  todo_calendar_connect_body_web: "Συνδέστε ένα ημερολόγιο στις ρυθμίσεις συγχρονισμού ημερολογίου για να προσθέτετε εργασίες σε αυτό.",
  todo_calendar_connect: "Σύνδεση",
  todo_calendar_removed: "Αφαιρέθηκε από το ημερολόγιό σας",
  todo_calendar_added_later: "Προστέθηκε. Δεν ήταν δυνατή η πρόσβαση στο ημερολόγιό σας· το Kjuup θα προσπαθήσει ξανά αργότερα.",
  todo_calendar_added: "Προστέθηκε στο ημερολόγιό σας",
  todo_calendar_no_date: "Μόνο μια εργασία με ημερομηνία μπορεί να προστεθεί στο ημερολόγιο.",
  todo_calendar_failed: "Δεν ήταν δυνατή η ενημέρωση του ημερολογίου σας. Δοκιμάστε ξανά.",
  todo_calendar_date_title: "Δεν υπάρχει ακόμη ημερομηνία",
  todo_calendar_date_save: "Ορισμός ημερομηνίας και προσθήκη",
  todo_calendar_date_body_web: "Αυτή η αποθηκευμένη εργασία δεν έχει ακόμη ημερομηνία. Ορίστε μία για να την προσθέσετε στο ημερολόγιό σας.",
  kjuup_io_setup_saved: "Η ρύθμιση αποθηκεύτηκε",
  kjuup_io_setup_step: "Βήμα",
  kjuup_io_setup_chats_title: "Θέλετε να χρησιμοποιείτε συνομιλίες;",
  kjuup_io_setup_email_title: "Πού θέλετε να διαβάζετε τα email σας;",
  kjuup_io_setup_chats_sub: "Οι συνομιλίες με συναδέλφους και συνεργάτες έργων είναι προαιρετικές. Μπορείτε να τις εμφανίσετε ή να τις αποκρύψετε στο Cockpit ανά πάσα στιγμή.",
  kjuup_io_setup_email_sub: "Αυτό επιλέγει μόνο αν θα χρησιμοποιείτε πρόγραμμα email στο Kjuup ή θα συνεχίσετε με το τρέχον πρόγραμμα email σας, π.χ. Outlook ή άλλο. Μπορείτε να αλλάξετε αργότερα.",
  kjuup_io_setup_chats_yes: "Ναι, εμφάνιση συνομιλιών",
  kjuup_io_setup_chats_yes_text: "Τα «Μηνύματα» περιλαμβάνουν συνομιλίες και email. Τα έργα έχουν ομαδικές συνομιλίες για όλους τους συμμετέχοντες.",
  kjuup_io_setup_chats_no: "Όχι, εργασία χωρίς συνομιλίες",
  kjuup_io_setup_chats_no_text: "Οι συνομιλίες είναι κρυφές. Τα «Μηνύματα» γίνονται «Email»· τα έργα, οι εργασίες και οι ημερήσιες αναφορές παραμένουν.",
  kjuup_io_setup_email_client: "Πρόγραμμα email στο Kjuup",
  kjuup_io_setup_email_client_text: "Διαβάστε και απαντήστε σε email απευθείας στο Kjuup.",
  kjuup_io_setup_email_reports: "Τρέχων πρόγραμμα email",
  kjuup_io_setup_email_reports_text: "Συνεχίστε να διαβάζετε και να απαντάτε στο τρέχον πρόγραμμά σας, π.χ. Outlook ή άλλο.",
  kjuup_io_setup_skip: "Αργότερα",
  next: "Επόμενο",
  kjuup_io_setup_finish: "Ολοκλήρωση ρύθμισης",
  today_label: "σήμερα",
  tomorrow_label: "αύριο",
  cockpit_todo_overdue: "καθυστερημένη",
  cockpit_report_management_fazit: "Σύνοψη για τη διοίκηση",
  cockpit_todo_appointment: "Ραντεβού",
  cockpit_todo_deadline: "Προθεσμία",
  cockpit_todo_deadline_define: "Ορισμός προθεσμίας",
  pro_todo_status_acknowledged: "Επιβεβαιώθηκε",
  pro_todo_responsible: "Υπεύθυνος",
  pro_todo_notice_confirmed: "Επιβεβαιώθηκε στη συνομιλία",
  pro_todo_notice_sent_at: "Το μήνυμα στάλθηκε",
  pro_todo_notice_again: "Νέα αποστολή του μηνύματος",
  pro_todo_notice_send: "Ενημέρωση μέσω μηνύματος Kjuup",
  pro_todo_add_assignee: "Προσθήκη",
  pro_todo_edit: "Επεξεργασία",
  pro_todo_change_room: "Αλλαγή έργου",
  pro_todo_due_on: "Προθεσμία έως",
  pro_todo_edit_due: "Επεξεργασία προθεσμίας",
  pro_todo_no_date: "Χωρίς ημερομηνία",
  pro_todo_edit_description: "Επεξεργασία περιγραφής",
  pro_todo_no_description: "Δεν υπάρχει ακόμη περιγραφή",
  pro_todo_title_label: "Τίτλος",
  pro_todo_title_placeholder: "Εισαγάγετε τίτλο...",
  pro_todo_task: "Εργασία",
  pro_todo_what: "Τι πρέπει να γίνει;",
  pro_todo_source_email: "Email",
  pro_todo_sources: "Πηγές",
  previous: "Προηγούμενο",
  kjuup_plus_abo_tier_large: "Kjuup+ Large (έως {max} εργαζόμενοι)",
  kjuup_plus_abo_tier_small: "Kjuup+ Small (έως {max} εργαζόμενοι)",
  kjuup_plus_abo_status_ends: "Λήγει στις {date}",
  kjuup_plus_abo_seats_over: "Πάνω από {max} εργαζόμενοι – η Kjuup θα επικοινωνήσει μαζί σας με εξατομικευμένη προσφορά.",
  kjuup_plus_abo_seats_next: "Αν προστεθούν περισσότεροι εργαζόμενοι, το πακέτο αλλάζει αυτόματα σε {next} (με αναλογική χρέωση).",
  kjuup_plus_abo_seats_used: "{used} από {total} θέσεις σε χρήση",
  kjuup_plus_abo_seats_free: "Ελεύθερες θέσεις: {count}",
  kjuup_plus_abo_intro_until: "έως {date}",
  kjuup_plus_abo_invoice_open: "Ανοιχτό · λήξη {date}",
  kjuup_plus_abo_invoices_all: "Εμφάνιση όλων ({count})",
  kjuup_plus_abo_requested_hint: "Η ακύρωση ζητήθηκε στις {date}. Η Kjuup θα την επιβεβαιώσει στο τέλος της περιόδου ({end}).",
  kjuup_plus_abo_cancel_hint: "Η Kjuup εξετάζει το αίτημά σας και επιβεβαιώνει την ακύρωση στο τέλος της περιόδου ({end}). Μέχρι τότε το Kjuup+ παραμένει ενεργό.",
  kjuup_plus_abo_withdrawn: "Το αίτημα ακύρωσης αποσύρθηκε",
  kjuup_plus_abo_requested: "Ζητήθηκε ακύρωση",
  cockpit_upsell_plus_intro_hint: "τους πρώτους {months} μήνες, μετά {price}",
  cockpit_upsell_plus_badge: "ΕΙΣΑΓΩΓΙΚΗ ΤΙΜΗ ΓΙΑ {months} ΜΗΝΕΣ",
  calendar_syncing: "Ενημέρωση από το ημερολόγιο…",
  calendar_sync_up_to_date: "Το ημερολόγιο είναι ενημερωμένο",
  calendar_sync_failed: "Ο συγχρονισμός απέτυχε",
  delete_multiple_tasks_confirm: "Είστε σίγουροι ότι θέλετε να διαγράψετε {count} ToDo;",
  todos_deleted_count: "Διαγράφηκαν {count} ToDo",
  todos_deleted_partial: "Διαγράφηκαν {ok} ToDo, {fail} απέτυχαν",
  todo_unknown: "Άγνωστο",
  todo_created_from_message: "Δημιουργήθηκε εργασία από αυτό το μήνυμα",
  kjuup_io_todo_calendar_trial_ended_note: "Συγχρονισμός ημερολογίου · Συνδρομή",
  kjuup_io_todo_calendar_nudge: "Συγχρονισμός αυτού του ToDo με το ημερολόγιό σας;",
  kjuup_io_todo_calendar_nudge_cta: "Ενεργοποίηση Kjuup.io",
  todo_confirmed: "ToDo επιβεβαιώθηκε",
  pro_todo_bulk_delete_title: "Διαγραφή {{n}} εργασιών;",
  pro_todo_previous_none_own: "Οι εκπρόθεσμες εργασίες σάς ανατέθηκαν από άλλους και μόνο αυτοί μπορούν να τις διαγράψουν.",
  pro_todo_previous_none: "Δεν υπάρχουν εκπρόθεσμες εργασίες",
  pro_todo_previous_title: "Διαγραφή {{n}} εκπρόθεσμων εργασιών;",
  pro_todo_previous_text: "Όλες οι ανοιχτές εργασίες σας από προηγούμενες ημέρες θα διαγραφούν.",
  pro_todo_previous_skipped: "Παραμένουν {{n}} που σας ανατέθηκαν από άλλους.",
  unassign_task_confirm: "Θέλετε να ακυρώσετε την ανάθεσή σας από αυτή την εργασία;",
  unassign_label: "Ακύρωση",
  pro_todo_delete_title: "Διαγραφή εργασίας",
  pro_todo_today: "Σήμερα",
  pro_todo_yesterday: "Χθες",
  pro_todo_since_yesterday: "Από χθες",
  pro_todo_mark_open: "Σήμανση ως ανοιχτή",
  verify_completion: "Επαλήθευση",
  new_label: "Νέο",
  bookmarked_no_mylist: "Οι εργασίες με σελιδοδείκτη δεν μπορούν να προστεθούν στη Λίστα μου",
  delete_only_own: "Μπορείτε να διαγράψετε μόνο εργασίες που δημιουργήσατε εσείς",
  todo_clear_all: "Εκκαθάριση όλων",
  pro_todo_of_completed: "{{done}} από {{total}} ολοκληρώθηκαν",
  pro_todo_pick_date: "Επιλέξτε ημερομηνία",
  pro_todo_show_day: "Εμφάνιση ημέρας",
  todo_adjust_list: "Προσαρμογή λίστας",
  pro_todo_section_upcoming: "Επερχόμενα",
  pro_todo_section_done: "Ολοκληρωμένα",
  pro_todo_room_empty_today: "Δεν υπάρχουν εργασίες για σήμερα σε αυτό το έργο",
  pro_todo_room_empty_day: "Δεν υπάρχουν εργασίες αυτή την ημέρα σε αυτό το έργο",
  pro_todo_delete_previous: "Διαγραφή όλων",
  todo_my_list_empty: "Η μέρα σου είναι κενή",
  todo_my_list_empty_hint: "Κάντε κλικ στο «Προσαρμογή λίστας» για να προσθέσετε εργασίες",
  pro_todo_empty_title: "Τίποτα εδώ",
  pro_todo_empty_hint: "Καμία εργασία δεν ταιριάζει με αυτή την προβολή.",
  pro_todo_selected: "Επιλέχθηκαν: {{n}}",
  delete_selected_count: "Διαγραφή ({count})",
  pro_todo_adjust_done: "Τέλος",
  pro_todo_deleting: "Διαγραφή...",
  pro_todo_reopen: "Επανάνοιγμα εργασίας",
  pro_todo_step_done: "Ολοκληρώθηκε",
  move_back_in_progress: "Επιστροφή σε εξέλιξη",
  pro_todo_mark_not_started: "Σήμανση ως μη ξεκινημένη",
  back_into_in_progress: "Επιστροφή σε εξέλιξη",
  pro_todo_mark_in_progress: "Σήμανση ως σε εξέλιξη",
  unassign_todo: "Ακύρωση ανάθεσης ToDo",
  pro_todo_open_room: "Άνοιγμα έργου",
  pro_todo_new_task: "Νέα εργασία",
  select_user_back_to_in_progress: "Επιλέξτε χρήστη για επιστροφή σε εξέλιξη",
  cockpit_email_accounts_n_many: "{{n}} συνδεδεμένοι λογαριασμοί",
  // Kjuup + Microsoft Teams chats (new-chat pickers, combined groups)
  combined_tab_kjuup: "Επαφές Kjuup",
  combined_tab_teams: "Επαφές Teams",
  combined_bridge_failed: "Δεν ήταν δυνατή η δημιουργία αντιγράφου στο Teams.",
  combined_chat_label: "Kjuup + Teams",
  combined_guest_tag: "Teams",
  combined_new_group_note: "Επαφές Kjuup και Teams: δημιουργείται νέα ομάδα που εμφανίζεται και στο Microsoft Teams.",
  teams_new_chat_title: "Νέα συνομιλία Teams",
  teams_new_chat_topic: "Όνομα ομάδας (προαιρετικό)",
  teams_new_chat_start: "Έναρξη συνομιλίας",
  teams_new_chat_creating: "Δημιουργία συνομιλίας…",
  teams_new_chat_forbidden: "Το Microsoft Teams δεν επιτρέπει αυτή τη συνομιλία (π.χ. άτομο εκτός του οργανισμού σας ή πολιτική του τμήματος IT).",
  teams_new_chat_too_many: "Πάρα πολλά άτομα για μία συνομιλία.",
  teams_new_chat_type_hint: "Πληκτρολογήστε ένα όνομα για αναζήτηση στον οργανισμό σας.",
  teams_new_chat_directory_forbidden: "Ο οργανισμός σας δεν επιτρέπει την αναζήτηση στον κατάλογο. Εμφανίζονται μόνο άτομα από τις συνομιλίες σας στο Teams.",
  teams_new_chat_account: "Λογαριασμός",
};
